import React, { useState, useEffect, useContext, useRef } from "react";
import Image from "react-bootstrap/Image";
import Form from "react-bootstrap/Form";
import "react-phone-input-2/lib/style.css";
import Button from "react-bootstrap/Button";
import LoginBg from "../../images/newimg/login.jpg";
import PlaceholderImg from "../../images/placeholder.png";
import EditIcon from "../../images/edit.svg";
import {
  FaChevronDown,
  FaChevronUp,
  FaCloudUploadAlt,
  FaFilePdf,
  FaTimes,
} from "react-icons/fa";
import { toast } from "react-toastify";
import { ValidationsService } from "../../../utility/services/ValidationsService";
import ConstConfig from "../../../utility/configs/constConfig";
import Functions from "../../../utility/services/Functions";
import ApiService from "../../../utility/services/ApiService";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { AuthContext } from "../../../utility/services/AuthContext";
import { MultiSelect } from "react-multi-select-component";
import Select from "react-dropdown-select";
import Calendar from "react-calendar";
import Modal from "react-bootstrap/Modal";
import Otp_model_for_register from "../../common/components/Otp_model_for_register";
import heic2any from "heic2any";
import { trackScreenView, trackButtonClick, trackEvent } from "../../../utility/services/analyticsService";

const TherapistRegisteration = () => {
  // DATA VARIABLES

  const location = useLocation();

  let navigateFrom = location?.state?.navigateFrom || "";
  const isNavigateFromOptScreen = navigateFrom == "otp_screen";
  let phone = isNavigateFromOptScreen
    ? location?.state?.phone || ""
    : "";
  let socialData = !isNavigateFromOptScreen ? location?.state?.socialData || {} : {};
  const apple_id =
    Object.keys(socialData).length > 0 ? socialData.apple_id : "";

  const facebook_id =
    Object.keys(socialData).length > 0 ? socialData.facebook_id : "";

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [custom_phone, setCustomPhone] = useState("");
  const [dob, setDob] = useState("");
  const [gender, setGender] = useState("Male");
  const [email, setEmail] = useState(
    isNavigateFromOptScreen ? "" : socialData?.email
  );
  const [state, setState] = useState([]);
  const [speciality, setSpeciality] = useState([]);
  const [profile_img, setProfileImg] = useState("");
  const [certificates, setCertificates] = useState([]);
  const [id_proofs, setIdProofs] = useState([]);
  const [imgPreview, setImgPreview] = useState("");
  const [speciality_type_id, setSpecialityTypeId] = useState("");
  const [supervisor_name, setSupervisorName] = useState("");

  // LOGICAL VARIABLES

  const [specialityList, setSpecialityList] = useState([]);
  const [statesList, setStatesList] = useState([]);
  const [validationsRes, setValidationsRes] = useState({});
  const [submit, setSubmit] = useState(false);
  const [showDateModel, setShowDateModel] = useState(false);
  const [showExpiryDateModel, setShowExpiryDateModel] = useState(false);
  const [selected_license, setSelectedLicense] = useState({});
  const [show_otp_modal, setShowOtpModal] = useState(false);
  const [termsAndConditions, setTermsAndConditions] = useState(false);
  const [licenses, setLicenses] = useState([
    {
      license_number: "",
      state: [],
      document: null,
      expiry_date: "",
      verified: "not_checked",
      verifying: false,
    },
  ]);
  const [isAnyLicenseVerifying, setIsAnyLicenseVerifying] = useState(false);

  const {
    consoleService,
    formetDate,
    calculateAge,
    fileToBase64,
    localDateFromString,
    split_simple_year_date_month_from_str,
    get_simple_year_date_month_str,
    formatYMD,
  } = Functions();

  const {
    get_speciality,
    get_speciality_types,
    get_states,
    register_user,
    verify_license,
  } = ApiService();
  const { setLoading } = useContext(AuthContext);
  const navigate = useNavigate();

  const errorStyle = {
    position: "relative",
    top: -10,
  };

  // USE EFFECT

  useEffect(() => {
    if (!navigateFrom)
      return navigate("/login", {
        replace: true,
      });
    trackScreenView("signup_screen", { screen_name: "Sign Up", user_type: "public", signup_type: "therapist_signup" });
    fetch_lists();
  }, []);

  useEffect(() => {
    const spanElement = document.querySelector(".dropdown-heading-value .gray");
    if (spanElement) {
      spanElement.textContent = "Select Speciality";
    }
  }, [speciality]);

  useEffect(() => {
    validationsResFun();
  }, [
    firstName,
    dob,
    custom_phone,
    gender,
    email,
    speciality,
    id_proofs,
    licenses,
    supervisor_name,
  ]);

  // FUNCTIONS

  function validationsResFun() {
    setValidationsRes(
      ValidationsService({
        firstName,
        dob,
        phone: custom_phone,
        gender,
        email,
        speciality,
        id_proofs,
        licenses,
        supervisor_name,
      })
    );
  }

  const verifyLicense = async (index) => {
    const updatedLicenses = [...licenses];
    const license = updatedLicenses[index];

    // Check for duplicate license numbers
    const isDuplicate = licenses.some(
      (lic, i) =>
        i !== index &&
        lic.license_number.trim() &&
        lic.license_number.toUpperCase() ===
          license.license_number.toUpperCase()
    );

    if (isDuplicate) {
      toast(
        "This license number is already used. Please enter a different license number.",
        {
          position: "top-center",
          hideProgressBar: true,
          type: "error",
        }
      );
      return;
    }

    license.verifying = true;
    setIsAnyLicenseVerifying(true);
    setLicenses([...updatedLicenses]);

    try {
      const base64File = await fileToBase64(license.document);
      const requestData = {
        license_number: license.license_number,
        state: license.state[0].label,
        file: base64File,
      };

      const response = await verify_license(requestData);

      if (response.status === 1) {
        license.verified = "verified";
        license.expiry_date = response.data.expiry_date;
      } else {
        license.verified = "unverified";
        toast(response.message || "Verification failed", {
          position: "top-center",
          hideProgressBar: true,
          type: "info",
          style: {
            backgroundColor: "#1D7E7C",
            color: "white",
          },
        });
      }
    } catch (error) {
      consoleService("License verification error:", error);
      license.verified = "unverified";
      toast("Server error occurred", {
        position: "top-center",
        hideProgressBar: true,
        type: "error",
      });
    } finally {
      license.verifying = false;
      setIsAnyLicenseVerifying(false);
      setLicenses([...updatedLicenses]);
    }
  };

  async function fetch_lists() {
    setLoading(true);
    try {
      const res = await get_speciality_types();
      const states_res = await get_states();
      if (res.status === 1 && states_res.status === 1) {
        const modified_states_list = states_res.data.map((item) => {
          return { label: item.title, value: item._id };
        });
        setStatesList(modified_states_list);
        const typeId = res?.data?.[0]?._id;
        const list_res = await get_speciality(typeId);
        setSpecialityTypeId(typeId);
        if (list_res.status == 1) {
          const modifiedRes = list_res.data.map((item) => {
            return { label: item.title, value: item._id };
          });
          setSpecialityList([...modifiedRes]);

          if (!isNavigateFromOptScreen) {
            if (socialData.loginType == "google") {
              setFirstName(socialData.given_name);
              setLastName(socialData.family_name);
            } else if (socialData.loginType == "facebook") {
              const name = socialData.name.split(" ");
              setFirstName(name[0]);
              if (name.length > 1) {
                setLastName([name[1]]);
              }
            }
          }

          setLoading(false);
        }
      }
    } catch (err) {
      setLoading(false);
      consoleService("Error in fetch lists function = ", err);
    }
  }

  const select_profile_img = async (files) => {
    try {
      if (files.length > 0) {
        const file = files[0];
        const imageTypeRegex = /image\/(jpg|jpeg|png|heic)/gm;
        const isMatch = file.type.match(imageTypeRegex);
        if (isMatch) {
          if (file.type === "image/heic" || file.name.endsWith(".heic")) {
            try {
              const blob = await heic2any({
                blob: file,
                toType: "image/jpeg",
              });
              const convertedFile = new File(
                [blob],
                file.name.replace(".heic", ".jpg"),
                { type: "image/jpeg" }
              );
              setImgPreview(URL.createObjectURL(convertedFile));
              setProfileImg(convertedFile);
            } catch (error) {
              toast(
                "Failed to process HEIC image. Please upload a JPG or PNG instead.",
                {
                  position: "top-center",
                  hideProgressBar: true,
                  type: "error",
                }
              );
              return;
            }
          } else {
            setImgPreview(URL.createObjectURL(file));
            setProfileImg(file);
          }
        } else {
          toast("Please select a file in JPG, PNG, HEIC, or JPEG format.", {
            position: "top-center",
            hideProgressBar: true,
            type: "error",
          });
        }
      }
    } catch (err) {
      consoleService("err in select_profile_image =", err);
    }
  };

  const select_certificates = async (files) => {
    try {
      const imageTypeRegex = /(application|image)\/(pdf|jpeg|jpg|png|heic)/gm;
      const vaildDocs = [];
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const maxSize = 3 * 1024 * 1024;
        if (file.size > maxSize)
          return toast("File size of your documents should not exceed 3 MB.", {
            position: "top-center",
            hideProgressBar: true,
            type: "error",
          });
        if (file.type.match(imageTypeRegex)) {
          if (file.type === "image/heic" || file.name.endsWith(".heic")) {
            try {
              const blob = await heic2any({
                blob: file,
                toType: "image/jpeg",
              });
              const convertedFile = new File(
                [blob],
                file.name.replace(".heic", ".jpg"),
                { type: "image/jpeg" }
              );
              vaildDocs.push(convertedFile);
            } catch (error) {
              toast(
                "Failed to process HEIC image. Please upload a JPG or PNG instead.",
                {
                  position: "top-center",
                  hideProgressBar: true,
                  type: "error",
                }
              );
              return;
            }
          } else {
            vaildDocs.push(file);
          }
        } else {
          consoleService("fileType = ", file.type);
          return toast("You can select only (pdf,jpeg,jpg,png,heic) files.", {
            position: "top-center",
            hideProgressBar: true,
            type: "error",
          });
        }
      }

      if (vaildDocs.length > 0) {
        setCertificates(vaildDocs);
        return;
      }
    } catch (err) {
      consoleService("error in select certificate", err);
    }
  };

  const select_id_proofs = async (files) => {
    try {
      const imageTypeRegex = /(application|image)\/(pdf|jpeg|jpg|png|heic)/gm;
      const vaildDocs = [];
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const maxSize = 3 * 1024 * 1024;
        if (file.size > maxSize)
          return toast("File size of your documents should not exceed 3 MB.", {
            position: "top-center",
            hideProgressBar: true,
            type: "error",
          });
        if (file.type.match(imageTypeRegex)) {
          if (file.type === "image/heic" || file.name.endsWith(".heic")) {
            try {
              const blob = await heic2any({
                blob: file,
                toType: "image/jpeg",
              });
              const convertedFile = new File(
                [blob],
                file.name.replace(".heic", ".jpg"),
                { type: "image/jpeg" }
              );
              vaildDocs.push(convertedFile);
            } catch (error) {
              toast(
                "Failed to process HEIC image. Please upload a JPG or PNG instead.",
                {
                  position: "top-center",
                  hideProgressBar: true,
                  type: "error",
                }
              );
              return;
            }
          } else {
            vaildDocs.push(file);
          }
        } else {
          return toast("You can select only (pdf,jpeg,jpg,png,heic) files.", {
            position: "top-center",
            hideProgressBar: true,
            type: "error",
          });
        }
      }

      if (vaildDocs.length > 0) {
        setIdProofs(vaildDocs);
        return;
      }
    } catch (err) {
      consoleService("error in select proof = ", err);
    }
  };

  const isLicenseComplete = (lic) =>
    lic.license_number?.trim() &&
    Array.isArray(lic.state) &&
    lic.state.length > 0 &&
    lic.document &&
    lic.expiry_date?.toString().trim();

  const validateLicenses = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    for (const lic of licenses) {
      if (!isLicenseComplete(lic)) {
        return "All license fields are required";
      }

      const exp = new Date(lic.expiry_date);
      exp.setHours(0, 0, 0, 0);
      if (exp < today) {
        return "License expiry date must be today or in the future";
      }
    }

    const seen = new Set();
    for (const lic of licenses) {
      const k = String(lic.license_number).toUpperCase().trim();
      if (seen.has(k)) {
        return "Duplicate license numbers are not allowed.";
      }
      seen.add(k);
    }

    return null;
  };

  // Not used anymore for gating verify/expiry; keep signature to avoid breakage
  const validateLicensesForExpiryDate = () => null;
  const submitFun = async () => {
    trackButtonClick("signup_cta", {
      button_name: "Submit",
      screen_name: "Sign Up",
      signup_type: "therapist_signup",
      user_name: `${firstName} ${lastName}`.trim(),
      email: email,
      phone: phone || (custom_phone ? `+1${custom_phone.trim()}` : ""),
    });
    if (!navigateFrom)
      return navigate("/login", {
        replace: true,
      });
    let ConditionCheck = false;
    const isCustomPhoneFound = custom_phone.trim() != "";
    const isNavigateFromOtpScreen = navigateFrom == "otp_screen";
    if (isNavigateFromOtpScreen) {
      if (phone) {
        ConditionCheck = true;
      } else {
        ConditionCheck = false;
      }
    } else {
      if (isCustomPhoneFound && validationsRes.phoneErr)
        return toast(validationsRes.phoneErr, {
          position: "top-center",
          hideProgressBar: true,
          type: "error",
        });
      ConditionCheck = true;
    }
    if (!(calculateAge(dob) >= 12))
      return toast("You must be above 12 years of age to register.", {
        position: "top-center",
        hideProgressBar: true,
        type: "error",
      });

    setSubmit(true);
    const licenseValidationError = validateLicenses();
    if (licenseValidationError) {
      toast(licenseValidationError, {
        position: "top-center",
        hideProgressBar: true,
        type: "error",
      });
      return;
    }

    if (
      !validationsRes.firstNameErr &&
      !validationsRes.dobErr &&
      !validationsRes.emailErr &&
      !validationsRes.specialityErr &&
      !validationsRes.id_proofsErr &&
      termsAndConditions &&
      ConditionCheck
    ) {
      try {
        const isPhoneToUpdate = isNavigateFromOptScreen
          ? false
          : isCustomPhoneFound
          ? true
          : false;
        if (isPhoneToUpdate) return setShowOtpModal(true);

        await register_function(phone);
      } catch (err) {
        setLoading(false);
        consoleService("Error in submit function = ", err);
      }
    } else {
      toast("Some fields are missing.", {
        position: "top-center",
        hideProgressBar: true,
        type: "error",
      });
    }
  };

  const register_function = async (phone_no_to_update) => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("first_name", firstName);
      formData.append("last_name", lastName);
      formData.append("dob", dob);
      formData.append("email", email);
      formData.append("apple_id", apple_id);
      formData.append("facebook_id", facebook_id);
      formData.append("gender", gender);
      formData.append("speciality_type_id", speciality_type_id);
      formData.append("supervisor_name", supervisor_name);
      formData.append("terms", termsAndConditions);
      id_proofs.forEach((item) => {
        formData.append("id_proof", item);
      });

      // Send licenses array instead of single license_number
      const licensesData = licenses.map((lic, index) => ({
        license_number: lic.license_number,
        state: lic?.state?.length > 0 ? lic.state[0]?.value : "",
        file_path: "",
        expiry_date: formetDate(lic.expiry_date),
        verified: lic.verified,
      }));
      formData.append("licenses", JSON.stringify(licensesData));

      // Append license documents
      licenses.forEach((lic, index) => {
        if (lic.document) {
          formData.append(`license_document_${index}`, lic.document);
        }
      });

      formData.append("role", "Therapist");
      formData.append("profile_img", profile_img);
      formData.append("phone", phone_no_to_update);
      formData.append(
        "speciality_id",
        JSON.stringify(speciality.map((item) => item.value))
      );

      const res = await register_user(formData);
      if (res.status === 1) {
        trackEvent("therapist_registration", { event_type: "event", user_name: `${firstName} ${lastName}`.trim(), email: email, phone: phone_no_to_update });
        clearFields();
        setLoading(false);
        setSubmit(false);

        navigate("/therapistcompleteprofile", {
          state: res.data._id,
          replace: true,
        });
      } else {
        setLoading(false);
        toast(res.message, {
          position: "top-center",
          hideProgressBar: true,
          type: "error",
        });
      }
    } catch (err) {
      consoleService("error in register_function ", err);
    }
  };

  function clearFields() {
    setFirstName("");
    setLastName("");
    setDob("");
    setCustomPhone("");
    setGender("Male");
    setEmail("");
    setState("");
    setSpeciality("");
    setProfileImg("");
    setCertificates([]);
    setIdProofs([]);
    setImgPreview([]);
    setSpecialityTypeId("");
    phone = "";
  }

  function Date_model(props) {
    const [selectedDate, setSelectedDate] = useState(
      dob
        ? new Date(
            localDateFromString(split_simple_year_date_month_from_str(dob))
          )
        : new Date(1940, 0, 1)
    );
    return (
      <Modal
        {...props}
        size="md"
        className="modalregs"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => {
          setSelectedDate(new Date(dob));
          setShowDateModel(false);
        }}
      >
        <Modal.Body className="text-left">
          <section className="pb-4 pt-2 packagebox packagebox_book">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <h2>Select Date</h2>
                  <Calendar
                    onChange={(date) => {
                      setSelectedDate(new Date(date));
                    }}
                    value={selectedDate}
                    minDate={new Date(1940, 0, 1)}
                    maxDate={new Date()}
                    tileClassName="calendar_tiles"
                  />
                </div>
              </div>
            </div>
          </section>
        </Modal.Body>
        <Modal.Footer>
          <Button
            as={Link}
            onClick={(e) => {
              e.preventDefault();
              setDob(formatYMD(selectedDate));

              setShowDateModel(false);
            }}
          >
            Done
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
  function Expiry_Date_model(props) {
    const lic = selected_license;
    const index = lic.index;
    const [selectedDate, setSelectedDate] = useState(
      lic.expiry_date
        ? localDateFromString(
            split_simple_year_date_month_from_str(lic.expiry_date)
          )
        : new Date()
    );
    return (
      <Modal
        {...props}
        size="md"
        className="modalregs"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => {
          setSelectedDate(new Date(lic.expiry_date));
          setShowExpiryDateModel(false);
        }}
      >
        <Modal.Body className="text-left">
          <section className="pb-4 pt-2 packagebox packagebox_book">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <h2>Select Date</h2>
                  <Calendar
                    onChange={(date) => {
                      setSelectedDate(new Date(date));
                    }}
                    value={selectedDate}
                    minDate={new Date()}
                    tileClassName="calendar_tiles"
                  />
                </div>
              </div>
            </div>
          </section>
        </Modal.Body>
        <Modal.Footer>
          <Button
            as={Link}
            onClick={(e) => {
              e.preventDefault();
              const updated = [...licenses];

              const modified_date = formatYMD(selectedDate);
              updated[index].expiry_date = modified_date;
              setLicenses(updated);
              setShowExpiryDateModel(false);
            }}
          >
            Done
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  return (
    <>
      <section
        className="loginBg"
        style={{ backgroundImage: `url(${LoginBg})` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <Form>
                <div className="loginBox loginUpdateBox">
                  <div className="userImg">
                    <Image
                      src={imgPreview ? imgPreview : PlaceholderImg}
                      className="userImage"
                      alt=""
                    />
                    <div>
                      <Image src={EditIcon} className="editIcon" alt="" />
                      <input
                        type="file"
                        accept="image/jpg, image/jpeg , image/heic , image/png"
                        className="edit_img"
                        multiple={false}
                        onChange={(e) => {
                          select_profile_img(e.target.files);
                        }}
                      />
                    </div>
                  </div>
                  <Form.Label>Personal Information</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="First Name"
                    value={firstName}
                    onChange={(e) => {
                      setFirstName(e.target.value);
                    }}
                  />
                  {submit && validationsRes.firstNameErr && (
                    <span className="validations_err" style={errorStyle}>
                      {validationsRes.firstNameErr}
                    </span>
                  )}
                  <Form.Control
                    type="text"
                    placeholder="Last Name"
                    value={lastName}
                    onChange={(e) => {
                      setLastName(e.target.value);
                    }}
                  />
                  <Form.Control
                    className="mb-3"
                    type="text"
                    placeholder="D.O.B."
                    value={dob && get_simple_year_date_month_str(dob)}
                    onClick={() => {
                      setShowDateModel(true);
                    }}
                  />
                  {submit && validationsRes.dobErr && (
                    <span className="validations_err" style={errorStyle}>
                      {validationsRes.dobErr}
                    </span>
                  )}
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlInput3"
                  >
                    <Form.Label>What is your gender?</Form.Label>
                    {["radio"].map((type) => (
                      <div key={`default-${type}`} className="boxFlex">
                        <Form.Check // prettier-ignore
                          type={type}
                          id="g1"
                          label="Male"
                          name="gender"
                          checked={gender == "Male"}
                          onClick={() => {
                            setGender("Male");
                          }}
                        />
                        <Form.Check // prettier-ignore
                          type={type}
                          id="g2"
                          label="Female"
                          name="gender"
                          checked={gender == "Female"}
                          onClick={() => {
                            setGender("Female");
                          }}
                        />
                        <Form.Check // prettier-ignore
                          type={type}
                          id="g3"
                          label="Unspecified"
                          name="gender"
                          checked={gender == "Unspecified"}
                          onClick={() => {
                            setGender("Unspecified");
                          }}
                        />
                      </div>
                    ))}
                  </Form.Group>
                  <Form.Control
                    type="text"
                    placeholder="Email Address"
                    value={email}
                    onChange={(e) => {
                      (isNavigateFromOptScreen || apple_id.trim()) &&
                        setEmail(e.target.value);
                    }}
                  />
                  {submit && validationsRes.emailErr && (
                    <span className="validations_err" style={errorStyle}>
                      {validationsRes.emailErr}
                    </span>
                  )}
                  {!phone && (
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlInput2"
                    >
                      <div className="pbox register_pb_box">
                        <div className="callb">
                          US{" "}
                          <svg
                            width="12"
                            height="8"
                            viewBox="0 0 12 8"
                            fill="none"
                            x
                          >
                            <path
                              d="M1 1.5L6 6.5L11 1.5"
                              stroke="#212529"
                              stroke-width="1.66667"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span
                            style={{
                              color: !custom_phone.trim() ? "#929fa4" : null,
                            }}
                          >
                            +1
                          </span>
                        </div>
                        <Form.Control
                          type="text"
                          className="register_phone_input"
                          value={custom_phone}
                          onChange={(e) => {
                            const numericValue = e.target.value.replace(
                              /[^0-9]/g,
                              ""
                            );
                            setCustomPhone(numericValue);
                          }}
                          onKeyDown={(e) => {
                            if (e.key == "Enter") {
                              e.preventDefault();
                            }
                          }}
                          placeholder="(555) 000-0000"
                        />
                      </div>
                    </Form.Group>
                  )}

                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlInput3"
                  >
                    <MultiSelect
                      options={specialityList}
                      value={speciality}
                      onChange={setSpeciality}
                      labelledBy="Select Specialty"
                      className="checkBoxNew"
                    />
                  </Form.Group>
                  {submit && validationsRes.specialityErr && (
                    <span className="validations_err" style={errorStyle}>
                      {validationsRes.specialityErr}
                    </span>
                  )}
                  <Form.Label>Licensing Information</Form.Label>
                  <Form.Group
                    className="mt-3"
                    controlId="exampleForm.ControlInput3"
                  >
                    {licenses.map((lic, index) => (
                      <div
                        key={index}
                        className="licenseBox shadow p-3 mt-3 mb-3 bg-body rounded position-relative"
                      >
                        <div className="d-flex align-items-center  pb-1">
                          <p className="mb-0 me-2">License #{index + 1}</p>
                          <div className="ms-auto d-flex align-items-center me-3">
                            {lic.verified === "verified" && (
                              <span
                                className="badge bg-success"
                                style={{ fontSize: "12px" }}
                              >
                                Verified
                              </span>
                            )}
                            {lic.verified === "unverified" && (
                              <>
                                <span
                                  className="badge bg-danger"
                                  style={{ fontSize: "12px" }}
                                >
                                  Unverified
                                </span>
                                <span
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "13px",
                                    color: "#1D7E7C",
                                    textDecoration: "underline",
                                    fontWeight: "bold",
                                    marginLeft: "5px",
                                  }}
                                  onClick={() => {
                                    const updated = [...licenses];
                                    updated[index] = {
                                      ...updated[index],
                                      verified: "not_checked",
                                    };
                                    setLicenses(updated);
                                    document.getElementById(
                                      `license-file-${index}`
                                    ).value = null;
                                  }}
                                >
                                  Try again
                                </span>
                              </>
                            )}
                          </div>
                        </div>
                        {/* REMOVE BUTTON */}
                        {licenses.length > 1 && (
                          <FaTimes
                            className="position-absolute"
                            style={{
                              top: 10,
                              right: 10,
                              cursor: isAnyLicenseVerifying
                                ? "not-allowed"
                                : "pointer",
                              color: "red",
                              opacity: isAnyLicenseVerifying ? 0.5 : 1,
                            }}
                            onClick={() => {
                              if (!isAnyLicenseVerifying) {
                                const updated = [...licenses];
                                updated.splice(index, 1);
                                setLicenses(updated);
                              }
                            }}
                          />
                        )}

                        <Form.Control
                          type="text"
                          placeholder="License Number"
                          value={lic.license_number}
                          onChange={(e) => {
                            const updated = [...licenses];
                            updated[index].license_number =
                              e.target.value.toUpperCase();
                            setLicenses(updated);
                          }}
                          style={{
                            textTransform: lic.license_number
                              ? "uppercase"
                              : "none",
                          }}
                        />

                        <Select
                          placeholder="Select State"
                          options={statesList}
                          values={lic.state}
                          onChange={(value) => {
                            const updated = [...licenses];
                            updated[index].state = value;
                            setLicenses(updated);
                          }}
                          multi={false}
                          dropdownHandleRenderer={({ state }) => (
                            <span>
                              {state.dropdown ? (
                                <FaChevronUp />
                              ) : (
                                <FaChevronDown />
                              )}
                            </span>
                          )}
                        />

                        {/* UPLOAD BOX */}
                        <div className="uploadBox mt-3">
                          <p>Please upload proof of license certification</p>
                          <div
                            className="file"
                            style={{ position: "relative", cursor: "pointer" }}
                            onClick={() => {
                              const fileInput = document.getElementById(
                                `license-file-${index}`
                              );
                              if (fileInput) fileInput.value = null;
                              document
                                .getElementById(`license-file-${index}`)
                                .click();
                            }}
                          >
                            {licenses[index].document ? (
                              licenses[index].document.type.includes(
                                "image"
                              ) ? (
                                <img
                                  src={URL.createObjectURL(
                                    licenses[index].document
                                  )}
                                  alt="preview"
                                  style={{
                                    width: "100%",
                                    height: "150px",
                                    objectFit: "contain",
                                    border: "1px solid #ccc",
                                  }}
                                />
                              ) : (
                                <div
                                  style={{
                                    width: "100%",
                                    height: "150px",
                                    border: "1px solid #ccc",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexDirection: "column",
                                  }}
                                >
                                  <FaFilePdf size={40} color="red" />
                                  <p style={{ fontSize: "12px", marginTop: 5 }}>
                                    {licenses[index].document.name}
                                  </p>
                                </div>
                              )
                            ) : (
                              <span
                                className="select_license_document_box"
                                htmlFor={`license-file-${index}`}
                              >
                                <FaCloudUploadAlt /> Upload document
                              </span>
                            )}
                            <input
                              id={`license-file-${index}`}
                              type="file"
                              accept=".pdf,.jpg,.jpeg,.png,.heic"
                              style={{ display: "none" }}
                              onChange={async (e) => {
                                const file = e.target.files[0];
                                const updated = [...licenses];

                                if (!file) {
                                  updated[index].document = null;
                                  setLicenses(updated);
                                  return;
                                }

                                const validTypes = [
                                  "image/jpeg",
                                  "image/png",
                                  "image/jpg",
                                  "application/pdf",
                                  "image/heic",
                                ];
                                if (!validTypes.includes(file.type)) {
                                  toast(
                                    "Invalid file type. Only JPG, PNG, PDF, HEIC allowed",
                                    {
                                      position: "top-center",
                                      hideProgressBar: true,
                                      type: "error",
                                    }
                                  );
                                  updated[index].document = null;
                                  setLicenses(updated);
                                  return;
                                }

                                if (file.size > 10 * 1024 * 1024) {
                                  toast("File size exceeds 10MB limit", {
                                    position: "top-center",
                                    hideProgressBar: true,
                                    type: "error",
                                  });
                                  updated[index].document = null;
                                  setLicenses(updated);
                                  return;
                                }

                                if (
                                  file.type === "image/heic" ||
                                  file.name.endsWith(".heic")
                                ) {
                                  try {
                                    const blob = await heic2any({
                                      blob: file,
                                      toType: "image/jpeg",
                                    });
                                    const convertedFile = new File(
                                      [blob],
                                      file.name.replace(".heic", ".jpg"),
                                      { type: "image/jpeg" }
                                    );
                                    updated[index].document = convertedFile;
                                  } catch (error) {
                                    toast(
                                      "Failed to process HEIC image. Please upload a JPG or PNG instead.",
                                      {
                                        position: "top-center",
                                        hideProgressBar: true,
                                        type: "error",
                                      }
                                    );
                                    updated[index].document = null;
                                    setLicenses(updated);
                                    return;
                                  }
                                } else {
                                  updated[index].document = file;
                                }

                                setLicenses(updated);
                              }}
                            />
                          </div>
                          <small>
                            File size of your documents should not exceed 10 MB
                          </small>
                        </div>

                        {/* EXPIRY DATE */}
                        <div className="mt-3">
                          <Form.Label>License Expiry Date</Form.Label>
                          <Form.Control
                            type="text"
                            value={
                              lic?.expiry_date
                                ? get_simple_year_date_month_str(
                                    lic.expiry_date
                                  )
                                : ""
                            }
                            placeholder="Expiry Date"
                            onClick={(e) => {
                              setSelectedLicense({ ...lic, index });
                              setShowExpiryDateModel(true);
                            }}
                            readOnly
                          />
                          {submit && !lic?.expiry_date && (
                            <span
                              className="validations_err"
                              style={errorStyle}
                            >
                              This field is required
                            </span>
                          )}
                        </div>
                      </div>
                    ))}

                    {licenses.every(isLicenseComplete) && (
                      <Button
                        className="mb-3"
                        onClick={() =>
                          setLicenses([
                            ...licenses,
                            {
                              license_number: "",
                              state: [],
                              document: null,
                              expiry_date: "",
                              verified: "not_checked", // kept to avoid structure changes
                              verifying: false, // kept to avoid structure changes
                            },
                          ])
                        }
                        style={{
                          whiteSpace: "nowrap",
                          textAlign: "center",
                          minWidth: "200px",
                          width: "auto",
                        }}
                      >
                        Add More License
                      </Button>
                    )}
                    {submit && validationsRes.licensesErr && (
                      <span className="validations_err" style={errorStyle}>
                        {validationsRes.licensesErr}
                      </span>
                    )}
                  </Form.Group>

                  <Form.Control
                    type="text"
                    placeholder="Supervisor's Name (if applicable)"
                    value={supervisor_name}
                    onChange={(e) => {
                      setSupervisorName(e.target.value);
                    }}
                  />

                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlInput3"
                  >
                    <div className="uploadBox">
                      <p>
                        Please upload your state ID card or state driver license
                      </p>
                      <div className="file">
                        {id_proofs.length > 0 ? (
                          id_proofs.length == 1 ? (
                            <label htmlFor="input-file2">
                              {id_proofs.length} ID selected
                            </label>
                          ) : (
                            <label htmlFor="input-file2">
                              {id_proofs.length} ID's selected
                            </label>
                          )
                        ) : (
                          <label htmlFor="input-file2">
                            <FaCloudUploadAlt /> Upload ID
                          </label>
                        )}
                        <input
                          id="input-file2"
                          type="file"
                          accept=".pdf,.jpg,.jpeg,.png,.heic"
                          onChange={(e) => {
                            select_id_proofs(e.target.files);
                          }}
                          multiple
                        />
                      </div>
                      <small>
                        File size of your documents should not exceed 3 MB
                      </small>
                    </div>
                  </Form.Group>
                  {submit && validationsRes.id_proofsErr && (
                    <span className="validations_err" style={errorStyle}>
                      {validationsRes.id_proofsErr}
                    </span>
                  )}
                  <Form.Group
                    className="mb-4"
                    controlId="exampleForm.ControlInput3"
                  >
                    <Form.Label>HIPAA Compliance</Form.Label>
                    {["checkbox"].map((type) => (
                      <div key={`default-${type}`} className="mb-3 termBox">
                        <Form.Check // prettier-ignore
                          type={type}
                          id="1"
                          checked={termsAndConditions}
                          label={
                            <span>
                              I accept the{" "}
                              <Link
                                to=""
                                onClick={(e) => {
                                  e.preventDefault();
                                  window.open("/termsofservice");
                                }}
                                className="linkhip"
                              >
                                terms and conditions
                              </Link>
                              {" - "}
                              <Link
                                to=""
                                onClick={(e) => {
                                  e.preventDefault();
                                  window.open("/hipaa");
                                }}
                                className="linkhip"
                              >
                                HIPAA
                              </Link>{" "}
                              while sharing my details
                            </span>
                          }
                          onClick={() => {
                            setTermsAndConditions(!termsAndConditions);
                          }}
                        />
                      </div>
                    ))}
                  </Form.Group>
                  <Button
                    className="btn btn-primary me-3"
                    onClick={() => {
                      submitFun();
                    }}
                    disabled={!termsAndConditions}
                  >
                    Submit
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </section>
      {show_otp_modal && (
        <Otp_model_for_register
          show={true}
          onHide={() => {
            setShowOtpModal(false);
          }}
          verify_type="update_profile"
          phone_number={custom_phone}
          register_function={register_function}
        />
      )}
      <Date_model show={showDateModel} />
      <Expiry_Date_model show={showExpiryDateModel} />
    </>
  );
};

export default TherapistRegisteration;

// import React, { useState, useEffect, useContext, useRef } from "react";
// import Image from "react-bootstrap/Image";
// import Form from "react-bootstrap/Form";
// import "react-phone-input-2/lib/style.css";
// import Button from "react-bootstrap/Button";
// import LoginBg from "../../images/newimg/login.jpg";
// import PlaceholderImg from "../../images/placeholder.png";
// import EditIcon from "../../images/edit.svg";
// import {
//   FaChevronDown,
//   FaChevronUp,
//   FaCloudUploadAlt,
//   FaFilePdf,
//   FaTimes,
// } from "react-icons/fa";
// import { toast } from "react-toastify";
// import { ValidationsService } from "../../../utility/services/ValidationsService";
// import ConstConfig from "../../../utility/configs/constConfig";
// import Functions from "../../../utility/services/Functions";
// import ApiService from "../../../utility/services/ApiService";
// import { useNavigate, useLocation, Link } from "react-router-dom";
// import { AuthContext } from "../../../utility/services/AuthContext";
// import { MultiSelect } from "react-multi-select-component";
// import Select from "react-dropdown-select";
// import Calendar from "react-calendar";
// import Modal from "react-bootstrap/Modal";
// import Otp_model_for_register from "../../common/components/Otp_model_for_register";
// import heic2any from "heic2any";

// const TherapistRegisteration = () => {
//   // DATA VARIABLES

//   const location = useLocation();

//   let navigateFrom = location.state != null ? location.state.navigateFrom : "";
//   const isNavigateFromOptScreen = navigateFrom == "otp_screen";
//   let phone = isNavigateFromOptScreen
//     ? location.state != null
//       ? location.state.phone
//       : ""
//     : "";
//   let socialData = !isNavigateFromOptScreen ? location.state.socialData : {};
//   const apple_id =
//     Object.keys(socialData).length > 0 ? socialData.apple_id : "";

//   const facebook_id =
//     Object.keys(socialData).length > 0 ? socialData.facebook_id : "";

//   const [firstName, setFirstName] = useState("");
//   const [lastName, setLastName] = useState("");
//   const [custom_phone, setCustomPhone] = useState("");
//   const [dob, setDob] = useState("");
//   const [date_to_send, setDateToSend] = useState("");
//   const [gender, setGender] = useState("Male");
//   const [email, setEmail] = useState(
//     isNavigateFromOptScreen ? "" : socialData?.email
//   );
//   const [state, setState] = useState([]);
//   const [speciality, setSpeciality] = useState([]);
//   const [profile_img, setProfileImg] = useState("");
//   const [certificates, setCertificates] = useState([]);
//   const [id_proofs, setIdProofs] = useState([]);
//   const [imgPreview, setImgPreview] = useState("");
//   const [speciality_type_id, setSpecialityTypeId] = useState("");
//   const [license_number, setLicenseNumber] = useState("");
//   const [supervisor_name, setSupervisorName] = useState("");

//   // LOGICAL VARIABLES

//   const [specialityList, setSpecialityList] = useState([]);
//   const [statesList, setStatesList] = useState([]);
//   const [validationsRes, setValidationsRes] = useState({});
//   const [submit, setSubmit] = useState(false);
//   const [showDateModel, setShowDateModel] = useState(false);
//   const [show_otp_modal, setShowOtpModal] = useState(false);
//   const [termsAndConditions, setTermsAndConditions] = useState(false);
//   const [licenses, setLicenses] = useState([
//     {
//       license_number: "",
//       state: [],
//       document: null,
//       expiry_date: "",
//       verified: false,
//       verifying: false,
//     },
//   ]);
//   const [isAnyLicenseVerifying, setIsAnyLicenseVerifying] = useState(false);

//   const { consoleService, formetDate, calculateAge, fileToBase64 } =
//     Functions();

//   const {
//     get_speciality,
//     get_speciality_types,
//     get_states,
//     register_user,
//     verify_license,
//   } = ApiService();
//   const { setLoading } = useContext(AuthContext);
//   const navigate = useNavigate();

//   const errorStyle = {
//     position: "relative",
//     top: -10,
//   };

//   // USE EFFECT

//   useEffect(() => {
//     if (!navigateFrom)
//       return navigate("/login", {
//         replace: true,
//       });
//     fetch_lists();
//   }, []);

//   useEffect(() => {
//     const spanElement = document.querySelector(".dropdown-heading-value .gray");
//     if (spanElement) {
//       spanElement.textContent = "Select Speciality";
//     }
//   }, [speciality]);

//   useEffect(() => {
//     validationsResFun();
//   }, [
//     firstName,
//     dob,
//     custom_phone,
//     gender,
//     email,
//     speciality,
//     id_proofs,
//     licenses,
//     supervisor_name,
//   ]);

//   // FUNCTIONS

//   function validationsResFun() {
//     setValidationsRes(
//       ValidationsService({
//         firstName,
//         dob,
//         phone: custom_phone,
//         gender,
//         email,
//         speciality,
//         id_proofs,
//         licenses,
//         supervisor_name,
//       })
//     );
//   }

//   const canShowVerify = licenses.some(
//     (lic) => lic.license_number && lic.state.length > 0 && lic.document
//   );

//   const verifyLicense = async (index) => {
//     const updatedLicenses = [...licenses];
//     const license = updatedLicenses[index];

//     // Check for duplicate license numbers in all licenses (verified or not)
//     const isDuplicate = licenses.some(
//       (lic, i) =>
//         i !== index &&
//         lic.license_number.trim() &&
//         lic.license_number.toUpperCase() ===
//           license.license_number.toUpperCase()
//     );

//     if (isDuplicate) {
//       toast(
//         "This license number is already used. Please enter a different license number.",
//         {
//           position: "top-center",
//           hideProgressBar: true,
//           type: "error",
//         }
//       );
//       return;
//     }

//     // Start loading
//     license.verifying = true;
//     setIsAnyLicenseVerifying(true);
//     setLicenses([...updatedLicenses]);

//     try {
//       // Convert file to base64
//       const base64File = await fileToBase64(license.document);

//       const requestData = {
//         license_number: license.license_number,
//         state: license.state[0].label, // Send state name/code
//         file: base64File,
//       };

//       const response = await verify_license(requestData);

//       if (response.status === 1) {
//         license.verified = true;
//         license.expiry_date = response.data.expiry_date;
//       } else {
//         license.verified = false;
//         toast(response.message || "Verification failed", {
//           position: "top-center",
//           hideProgressBar: true,
//           type: "error",
//         });
//       }
//     } catch (error) {
//       consoleService("License verification error:", error);
//       license.verified = false;
//       toast("Server error occurred", {
//         position: "top-center",
//         hideProgressBar: true,
//         type: "error",
//       });
//     } finally {
//       // Stop loading
//       license.verifying = false;
//       setIsAnyLicenseVerifying(false);
//       setLicenses([...updatedLicenses]);
//     }
//   };

//   async function fetch_lists() {
//     setLoading(true);
//     try {
//       const res = await get_speciality_types();
//       const states_res = await get_states();
//       if (res.status === 1 && states_res.status === 1) {
//         const modified_states_list = states_res.data.map((item) => {
//           return { label: item.title, value: item._id };
//         });
//         setStatesList(modified_states_list);
//         const typeId = res.data[0]._id;
//         const list_res = await get_speciality(typeId);
//         setSpecialityTypeId(typeId);
//         if (list_res.status == 1) {
//           const modifiedRes = list_res.data.map((item) => {
//             return { label: item.title, value: item._id };
//           });
//           setSpecialityList([...modifiedRes]);

//           if (!isNavigateFromOptScreen) {
//             if (socialData.loginType == "google") {
//               setFirstName(socialData.given_name);
//               setLastName(socialData.family_name);
//             } else if (socialData.loginType == "facebook") {
//               const name = socialData.name.split(" ");
//               setFirstName(name[0]);
//               if (name.length > 1) {
//                 setLastName([name[1]]);
//               }
//             }
//           }

//           setLoading(false);
//         }
//       }
//     } catch (err) {
//       setLoading(false);
//       consoleService("Error in fetch lists function = ", err);
//     }
//   }

//   const select_profile_img = async (files) => {
//     try {
//       if (files.length > 0) {
//         const file = files[0];
//         const imageTypeRegex = /image\/(jpg|jpeg|png|heic)/gm;
//         const isMatch = file.type.match(imageTypeRegex);
//         if (isMatch) {
//           if (file.type === "image/heic" || file.name.endsWith(".heic")) {
//             try {
//               const blob = await heic2any({
//                 blob: file,
//                 toType: "image/jpeg",
//               });
//               const convertedFile = new File(
//                 [blob],
//                 file.name.replace(".heic", ".jpg"),
//                 { type: "image/jpeg" }
//               );
//               setImgPreview(URL.createObjectURL(convertedFile));
//               setProfileImg(convertedFile);
//             } catch (error) {
//               toast(
//                 "Failed to process HEIC image. Please upload a JPG or PNG instead.",
//                 {
//                   position: "top-center",
//                   hideProgressBar: true,
//                   type: "error",
//                 }
//               );
//               return;
//             }
//           } else {
//             setImgPreview(URL.createObjectURL(file));
//             setProfileImg(file);
//           }
//         } else {
//           toast("Please select a file in JPG, PNG, HEIC, or JPEG format.", {
//             position: "top-center",
//             hideProgressBar: true,
//             type: "error",
//           });
//         }
//       }
//     } catch (err) {
//       consoleService("err in select_profile_image =", err);
//     }
//   };

//   const select_certificates = async (files) => {
//     try {
//       const imageTypeRegex = /(application|image)\/(pdf|jpeg|jpg|png|heic)/gm;
//       const vaildDocs = [];
//       for (let i = 0; i < files.length; i++) {
//         const file = files[i];
//         const maxSize = 3 * 1024 * 1024;
//         if (file.size > maxSize)
//           return toast("File size of your documents should not exceed 3 MB.", {
//             position: "top-center",
//             hideProgressBar: true,
//             type: "error",
//           });
//         if (file.type.match(imageTypeRegex)) {
//           if (file.type === "image/heic" || file.name.endsWith(".heic")) {
//             try {
//               const blob = await heic2any({
//                 blob: file,
//                 toType: "image/jpeg",
//               });
//               const convertedFile = new File(
//                 [blob],
//                 file.name.replace(".heic", ".jpg"),
//                 { type: "image/jpeg" }
//               );
//               vaildDocs.push(convertedFile);
//             } catch (error) {
//               toast(
//                 "Failed to process HEIC image. Please upload a JPG or PNG instead.",
//                 {
//                   position: "top-center",
//                   hideProgressBar: true,
//                   type: "error",
//                 }
//               );
//               return;
//             }
//           } else {
//             vaildDocs.push(file);
//           }
//         } else {
//           consoleService("fileType = ", file.type);
//           return toast("You can select only (pdf,jpeg,jpg,png,heic) files.", {
//             position: "top-center",
//             hideProgressBar: true,
//             type: "error",
//           });
//         }
//       }

//       if (vaildDocs.length > 0) {
//         setCertificates(vaildDocs);
//         return;
//       }
//     } catch (err) {
//       consoleService("error in select certificate", err);
//     }
//   };

//   const select_id_proofs = async (files) => {
//     try {
//       const imageTypeRegex = /(application|image)\/(pdf|jpeg|jpg|png|heic)/gm;
//       const vaildDocs = [];
//       for (let i = 0; i < files.length; i++) {
//         const file = files[i];
//         const maxSize = 3 * 1024 * 1024;
//         if (file.size > maxSize)
//           return toast("File size of your documents should not exceed 3 MB.", {
//             position: "top-center",
//             hideProgressBar: true,
//             type: "error",
//           });
//         if (file.type.match(imageTypeRegex)) {
//           if (file.type === "image/heic" || file.name.endsWith(".heic")) {
//             try {
//               const blob = await heic2any({
//                 blob: file,
//                 toType: "image/jpeg",
//               });
//               const convertedFile = new File(
//                 [blob],
//                 file.name.replace(".heic", ".jpg"),
//                 { type: "image/jpeg" }
//               );
//               vaildDocs.push(convertedFile);
//             } catch (error) {
//               toast(
//                 "Failed to process HEIC image. Please upload a JPG or PNG instead.",
//                 {
//                   position: "top-center",
//                   hideProgressBar: true,
//                   type: "error",
//                 }
//               );
//               return;
//             }
//           } else {
//             vaildDocs.push(file);
//           }
//         } else {
//           return toast("You can select only (pdf,jpeg,jpg,png,heic) files.", {
//             position: "top-center",
//             hideProgressBar: true,
//             type: "error",
//           });
//         }
//       }

//       if (vaildDocs.length > 0) {
//         setIdProofs(vaildDocs);
//         return;
//       }
//     } catch (err) {
//       consoleService("error in select proof = ", err);
//     }
//   };

//   const submitFun = async () => {
//     if (!navigateFrom)
//       return navigate("/login", {
//         replace: true,
//       });
//     let ConditionCheck = false;
//     const isCustomPhoneFound = custom_phone.trim() != "";
//     const isNavigateFromOtpScreen = navigateFrom == "otp_screen";
//     if (isNavigateFromOtpScreen) {
//       if (phone) {
//         ConditionCheck = true;
//       } else {
//         ConditionCheck = false;
//       }
//     } else {
//       if (isCustomPhoneFound && validationsRes.phoneErr)
//         return toast(validationsRes.phoneErr, {
//           position: "top-center",
//           hideProgressBar: true,
//           type: "error",
//         });
//       ConditionCheck = true;
//     }
//     if (!(calculateAge(dob) >= 12))
//       return toast("You must be above 12 years of age to register.", {
//         position: "top-center",
//         hideProgressBar: true,
//         type: "error",
//       });

//     // Check if all licenses are verified
//     const hasAllLicensesVerified = licenses.every((lic) => lic.verified);
//     if (!hasAllLicensesVerified) {
//       return toast("Please verify all licenses before submitting.", {
//         position: "top-center",
//         hideProgressBar: true,
//         type: "error",
//       });
//     }

//     setSubmit(true);
//     if (
//       !validationsRes.firstNameErr &&
//       !validationsRes.dobErr &&
//       !validationsRes.emailErr &&
//       !validationsRes.specialityErr &&
//       !validationsRes.id_proofsErr &&
//       termsAndConditions &&
//       ConditionCheck
//     ) {
//       try {
//         const isPhoneToUpdate = isNavigateFromOtpScreen
//           ? false
//           : isCustomPhoneFound
//           ? true
//           : false;
//         if (isPhoneToUpdate) return setShowOtpModal(true);

//         await register_function(phone);
//       } catch (err) {
//         setLoading(false);
//         consoleService("Error in submit function = ", err);
//       }
//     } else {
//       toast("Some fields are missing.", {
//         position: "top-center",
//         hideProgressBar: true,
//         type: "error",
//       });
//     }
//   };

//   const register_function = async (phone_no_to_update) => {
//     try {
//       setLoading(true);
//       const formData = new FormData();
//       formData.append("first_name", firstName);
//       formData.append("last_name", lastName);
//       formData.append("dob", date_to_send);
//       formData.append("email", email);
//       formData.append("apple_id", apple_id);
//       formData.append("facebook_id", facebook_id);
//       formData.append("gender", gender);
//       formData.append("speciality_type_id", speciality_type_id);
//       formData.append("supervisor_name", supervisor_name);
//       formData.append("terms", termsAndConditions);
//       id_proofs.forEach((item) => {
//         formData.append("id_proof", item);
//       });

//       // Send licenses array instead of single license_number
//       const licensesData = licenses.map((lic, index) => ({
//         license_number: lic.license_number,
//         state: lic.state.length > 0 ? lic.state[0].value : "",
//         file_path: "",
//         expiry_date: lic.expiry_date,
//         verified: lic.verified,
//       }));
//       formData.append("licenses", JSON.stringify(licensesData));

//       // Append license documents
//       licenses.forEach((lic, index) => {
//         if (lic.document) {
//           formData.append(`license_document_${index}`, lic.document);
//         }
//       });

//       formData.append("role", "Therapist");
//       formData.append("profile_img", profile_img);
//       formData.append("phone", phone_no_to_update);
//       formData.append(
//         "speciality_id",
//         JSON.stringify(speciality.map((item) => item.value))
//       );
//       formData.entries().forEach((entry) => {
//         console.log(entry);
//       });
//       const res = await register_user(formData);
//       if (res.status === 1) {
//         window.dataLayer = window.dataLayer || [];
//         window.dataLayer.push({
//           event: "therapist_registration",
//           email: email,
//           phone: phone_no_to_update,
//         });
//         clearFields();
//         setLoading(false);
//         setSubmit(false);

//         navigate("/therapistcompleteprofile", {
//           state: res.data._id,
//           replace: true,
//         });
//       } else {
//         setLoading(false);
//         toast(res.message, {
//           position: "top-center",
//           hideProgressBar: true,
//           type: "error",
//         });
//       }
//     } catch (err) {
//       consoleService("error in register_function ", err);
//     }
//   };

//   function clearFields() {
//     setFirstName("");
//     setLastName("");
//     setDob("");
//     setCustomPhone("");
//     setDateToSend("");
//     setGender("Male");
//     setEmail("");
//     setState("");
//     setSpeciality("");
//     setProfileImg("");
//     setCertificates([]);
//     setIdProofs([]);
//     setImgPreview([]);
//     setSpecialityTypeId("");
//     phone = "";
//   }

//   function Date_model(props) {
//     const [selectedDate, setSelectedDate] = useState(
//       dob ? new Date(dob) : new Date(1940, 0, 1)
//     );
//     return (
//       <Modal
//         {...props}
//         size="md"
//         className="modalregs"
//         aria-labelledby="contained-modal-title-vcenter"
//         centered
//         onHide={() => {
//           setSelectedDate(new Date(dob));
//           setShowDateModel(false);
//         }}
//       >
//         <Modal.Body className="text-left">
//           <section className="pb-4 pt-2 packagebox packagebox_book">
//             <div className="container">
//               <div className="row">
//                 <div className="col-md-12">
//                   <h2>Select Date</h2>
//                   <Calendar
//                     onChange={(date) => {
//                       setSelectedDate(new Date(date));
//                     }}
//                     value={selectedDate}
//                     minDate={new Date(1940, 0, 1)}
//                     maxDate={new Date()}
//                     tileClassName="calendar_tiles"
//                   />
//                 </div>
//               </div>
//             </div>
//           </section>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button
//             as={Link}
//             onClick={(e) => {
//               e.preventDefault();
//               setDob(
//                 `${selectedDate.getFullYear()}/${
//                   selectedDate.getMonth() + 1
//                 }/${selectedDate.getDate()}`
//               );
//               setDateToSend(selectedDate);
//               setShowDateModel(false);
//             }}
//           >
//             Done
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     );
//   }

//   return (
//     <>
//       <section
//         className="loginBg"
//         style={{ backgroundImage: `url(${LoginBg})` }}
//       >
//         <div className="container">
//           <div className="row">
//             <div className="col-md-12">
//               <Form>
//                 <div className="loginBox loginUpdateBox">
//                   <div className="userImg">
//                     <Image
//                       src={imgPreview ? imgPreview : PlaceholderImg}
//                       className="userImage"
//                       alt=""
//                     />
//                     <div>
//                       <Image src={EditIcon} className="editIcon" alt="" />
//                       <input
//                         type="file"
//                         accept="image/jpg, image/jpeg , image/heic , image/png"
//                         className="edit_img"
//                         multiple={false}
//                         onChange={(e) => {
//                           select_profile_img(e.target.files);
//                         }}
//                       />
//                     </div>
//                   </div>
//                   <Form.Label>Personal Information</Form.Label>
//                   <Form.Control
//                     type="text"
//                     placeholder="First Name"
//                     value={firstName}
//                     onChange={(e) => {
//                       setFirstName(e.target.value);
//                     }}
//                   />
//                   {submit && validationsRes.firstNameErr && (
//                     <span className="validations_err" style={errorStyle}>
//                       {validationsRes.firstNameErr}
//                     </span>
//                   )}
//                   <Form.Control
//                     type="text"
//                     placeholder="Last Name"
//                     value={lastName}
//                     onChange={(e) => {
//                       setLastName(e.target.value);
//                     }}
//                   />
//                   <Form.Control
//                     className="mb-3"
//                     type="text"
//                     placeholder="D.O.B."
//                     value={dob && formetDate(dob)}
//                     onClick={() => {
//                       setShowDateModel(true);
//                     }}
//                   />
//                   {submit && validationsRes.dobErr && (
//                     <span className="validations_err" style={errorStyle}>
//                       {validationsRes.dobErr}
//                     </span>
//                   )}
//                   <Form.Group
//                     className="mb-3"
//                     controlId="exampleForm.ControlInput3"
//                   >
//                     <Form.Label>What is your gender?</Form.Label>
//                     {["radio"].map((type) => (
//                       <div key={`default-${type}`} className="boxFlex">
//                         <Form.Check // prettier-ignore
//                           type={type}
//                           id="g1"
//                           label="Male"
//                           name="gender"
//                           checked={gender == "Male"}
//                           onClick={() => {
//                             setGender("Male");
//                           }}
//                         />
//                         <Form.Check // prettier-ignore
//                           type={type}
//                           id="g2"
//                           label="Female"
//                           name="gender"
//                           checked={gender == "Female"}
//                           onClick={() => {
//                             setGender("Female");
//                           }}
//                         />
//                         <Form.Check // prettier-ignore
//                           type={type}
//                           id="g3"
//                           label="Unspecified"
//                           name="gender"
//                           checked={gender == "Unspecified"}
//                           onClick={() => {
//                             setGender("Unspecified");
//                           }}
//                         />
//                       </div>
//                     ))}
//                   </Form.Group>
//                   <Form.Control
//                     type="text"
//                     placeholder="Email Address"
//                     value={email}
//                     onChange={(e) => {
//                       (isNavigateFromOptScreen || apple_id.trim()) &&
//                         setEmail(e.target.value);
//                     }}
//                   />
//                   {submit && validationsRes.emailErr && (
//                     <span className="validations_err" style={errorStyle}>
//                       {validationsRes.emailErr}
//                     </span>
//                   )}
//                   {!phone && (
//                     <Form.Group
//                       className="mb-3"
//                       controlId="exampleForm.ControlInput2"
//                     >
//                       {/* <Form.Label>Phone Number</Form.Label> */}
//                       <div className="pbox register_pb_box">
//                         <div className="callb">
//                           US{" "}
//                           <svg
//                             width="12"
//                             height="8"
//                             viewBox="0 0 12 8"
//                             fill="none"
//                             x
//                           >
//                             <path
//                               d="M1 1.5L6 6.5L11 1.5"
//                               stroke="#212529"
//                               stroke-width="1.66667"
//                               stroke-linecap="round"
//                               stroke-linejoin="round"
//                             />
//                           </svg>
//                           <span
//                             style={{
//                               color: !custom_phone.trim() ? "#929fa4" : null,
//                             }}
//                           >
//                             +1
//                           </span>
//                         </div>
//                         <Form.Control
//                           type="text"
//                           className="register_phone_input"
//                           value={custom_phone}
//                           onChange={(e) => {
//                             const numericValue = e.target.value.replace(
//                               /[^0-9]/g,
//                               ""
//                             );
//                             setCustomPhone(numericValue);
//                           }}
//                           onKeyDown={(e) => {
//                             if (e.key == "Enter") {
//                               e.preventDefault();
//                               // !validationsRes.phoneErr && send_otp_function();
//                             }
//                           }}
//                           placeholder="(555) 000-0000"
//                         />
//                       </div>
//                     </Form.Group>
//                   )}

//                   <Form.Group
//                     className="mb-3"
//                     controlId="exampleForm.ControlInput3"
//                   >
//                     <MultiSelect
//                       options={specialityList}
//                       value={speciality}
//                       onChange={setSpeciality}
//                       labelledBy="Select Specialty"
//                       className="checkBoxNew"
//                     />
//                   </Form.Group>
//                   {submit && validationsRes.specialityErr && (
//                     <span className="validations_err" style={errorStyle}>
//                       {validationsRes.specialityErr}
//                     </span>
//                   )}
//                   <Form.Label>Licensing Information</Form.Label>
//                   <Form.Group
//                     className="mt-3"
//                     controlId="exampleForm.ControlInput3"
//                   >
//                     {licenses.map((lic, index) => (
//                       <div
//                         key={index}
//                         className="licenseBox shadow p-3 mt-3 mb-3 bg-body rounded position-relative"
//                       >
//                         <div className="d-flex align-items-center  pb-1">
//                           <p className="mb-0 me-2">Sr.No {index + 1}</p>
//                           {lic.verified && (
//                             <span
//                               className="badge bg-success"
//                               style={{ fontSize: "12px" }}
//                             >
//                               Verified
//                             </span>
//                           )}
//                         </div>
//                         {/* REMOVE BUTTON */}
//                         {licenses.length > 1 && (
//                           <FaTimes
//                             className="position-absolute"
//                             style={{
//                               top: 10,
//                               right: 10,
//                               cursor: isAnyLicenseVerifying
//                                 ? "not-allowed"
//                                 : "pointer",
//                               color: "red",
//                               opacity: isAnyLicenseVerifying ? 0.5 : 1,
//                             }}
//                             onClick={() => {
//                               if (!isAnyLicenseVerifying) {
//                                 const updated = [...licenses];
//                                 updated.splice(index, 1);
//                                 setLicenses(updated);
//                               }
//                             }}
//                           />
//                         )}

//                         <Form.Control
//                           type="text"
//                           placeholder="License Number"
//                           value={lic.license_number}
//                           onChange={(e) => {
//                             if (!lic.verified && !isAnyLicenseVerifying) {
//                               const updated = [...licenses];
//                               updated[index].license_number =
//                                 e.target.value.toUpperCase();
//                               setLicenses(updated);
//                             }
//                           }}
//                           disabled={lic.verified || isAnyLicenseVerifying} // disable if verified or any license verifying
//                           style={{
//                             textTransform: lic.license_number
//                               ? "uppercase"
//                               : "none",
//                           }}
//                         />

//                         <Select
//                           placeholder="Select State"
//                           options={statesList}
//                           values={lic.state}
//                           onChange={(value) => {
//                             if (!lic.verified && !isAnyLicenseVerifying) {
//                               const updated = [...licenses];
//                               updated[index].state = value;
//                               setLicenses(updated);
//                             }
//                           }}
//                           multi={false}
//                           disabled={lic.verified || isAnyLicenseVerifying}
//                           style={{
//                             color: lic.verified ? "#212529" : undefined,
//                             borderColor: lic.verified ? "#E9ECEF" : undefined,
//                             opacity: lic.verified ? 1 : undefined,
//                             backgroundColor: lic.verified
//                               ? "#E9ECEF"
//                               : undefined,
//                           }}
//                           dropdownHandleRenderer={({ state }) => (
//                             <span
//                               style={{
//                                 color: lic.verified ? "#212529" : undefined,
//                                 opacity: lic.verified ? 0 : undefined,
//                               }}
//                             >
//                               {state.dropdown ? (
//                                 <FaChevronUp />
//                               ) : (
//                                 <FaChevronDown />
//                               )}
//                             </span>
//                           )}
//                         />

//                         {/* UPLOAD BOX */}
//                         <div className="uploadBox mt-3">
//                           <p>Please upload proof of license certification</p>
//                           <div
//                             className="file"
//                             style={{
//                               position: "relative",
//                               cursor:
//                                 lic.verified || isAnyLicenseVerifying
//                                   ? "not-allowed"
//                                   : "pointer",
//                             }}
//                             onClick={() => {
//                               if (!lic.verified && !isAnyLicenseVerifying)
//                                 document
//                                   .getElementById(`license-file-${index}`)
//                                   .click();
//                             }}
//                           >
//                             {licenses[index].document ? (
//                               licenses[index].document.type.includes(
//                                 "image"
//                               ) ? (
//                                 <img
//                                   src={URL.createObjectURL(
//                                     licenses[index].document
//                                   )}
//                                   alt="preview"
//                                   style={{
//                                     width: "100%",
//                                     height: "150px",
//                                     objectFit: "contain",
//                                     border: "1px solid #ccc",
//                                   }}
//                                 />
//                               ) : (
//                                 <div
//                                   style={{
//                                     width: "100%",
//                                     height: "150px",
//                                     border: "1px solid #ccc",
//                                     display: "flex",
//                                     alignItems: "center",
//                                     justifyContent: "center",
//                                     flexDirection: "column",
//                                   }}
//                                 >
//                                   <FaFilePdf size={40} color="red" />
//                                   <p style={{ fontSize: "12px", marginTop: 5 }}>
//                                     {licenses[index].document.name}
//                                   </p>
//                                 </div>
//                               )
//                             ) : (
//                               <span
//                                 className="select_license_document_box"
//                                 htmlFor={`license-file-${index}`}
//                               >
//                                 <FaCloudUploadAlt /> Upload document
//                               </span>
//                             )}
//                             <input
//                               id={`license-file-${index}`}
//                               type="file"
//                               accept=".pdf,.jpg,.jpeg,.png,.heic"
//                               style={{ display: "none" }}
//                               onChange={async (e) => {
//                                 if (!lic.verified && !isAnyLicenseVerifying) {
//                                   const file = e.target.files[0];
//                                   const updated = [...licenses];

//                                   // Check if file was selected
//                                   if (!file) {
//                                     updated[index].document = null;
//                                     setLicenses(updated);
//                                     return;
//                                   }

//                                   // Validate file type
//                                   const validTypes = [
//                                     "image/jpeg",
//                                     "image/png",
//                                     "image/jpg",
//                                     "application/pdf",
//                                     "image/heic",
//                                   ];
//                                   if (!validTypes.includes(file.type)) {
//                                     toast(
//                                       "Invalid file type. Only JPG, PNG, PDF, HEIC allowed",
//                                       {
//                                         position: "top-center",
//                                         hideProgressBar: true,
//                                         type: "error",
//                                       }
//                                     );
//                                     updated[index].document = null;
//                                     setLicenses(updated);
//                                     return;
//                                   }

//                                   // Validate file size (10MB)
//                                   if (file.size > 10 * 1024 * 1024) {
//                                     toast("File size exceeds 10MB limit", {
//                                       position: "top-center",
//                                       hideProgressBar: true,
//                                       type: "error",
//                                     });
//                                     updated[index].document = null;
//                                     setLicenses(updated);
//                                     return;
//                                   }

//                                   // Handle HEIC conversion if needed
//                                   if (
//                                     file.type === "image/heic" ||
//                                     file.name.endsWith(".heic")
//                                   ) {
//                                     try {
//                                       const blob = await heic2any({
//                                         blob: file,
//                                         toType: "image/jpeg",
//                                       });
//                                       const convertedFile = new File(
//                                         [blob],
//                                         file.name.replace(".heic", ".jpg"),
//                                         { type: "image/jpeg" }
//                                       );
//                                       updated[index].document = convertedFile;
//                                     } catch (error) {
//                                       toast(
//                                         "Failed to process HEIC image. Please upload a JPG or PNG instead.",
//                                         {
//                                           position: "top-center",
//                                           hideProgressBar: true,
//                                           type: "error",
//                                         }
//                                       );
//                                       updated[index].document = null;
//                                       setLicenses(updated);
//                                       return;
//                                     }
//                                   } else {
//                                     // Set valid file
//                                     updated[index].document = file;
//                                   }

//                                   setLicenses(updated);
//                                 }
//                               }}
//                             />
//                           </div>
//                           <small>
//                             File size of your documents should not exceed 10 MB
//                           </small>
//                         </div>

//                         {/* VERIFY BUTTON */}
//                         {!lic.verified &&
//                           lic.license_number &&
//                           lic.state.length > 0 &&
//                           lic.document && (
//                             <>
//                               <Button
//                                 className="mt-2"
//                                 onClick={() => verifyLicense(index)}
//                                 disabled={
//                                   lic.verifying || isAnyLicenseVerifying
//                                 }
//                               >
//                                 {lic.verifying ? "Verifying..." : "Verify"}
//                               </Button>
//                               {lic.verifying && (
//                                 <div
//                                   className="mt-2 p-2"
//                                   style={{
//                                     backgroundColor: "#e3f2fd",
//                                     border: "1px solid #1D7E7C",
//                                     borderRadius: "5px",
//                                     fontSize: "14px",
//                                     color: "#1A3D3C",
//                                   }}
//                                 >
//                                   <div className="d-flex align-items-center">
//                                     <div
//                                       className="spinner-border spinner-border-sm me-2"
//                                       role="status"
//                                     >
//                                       <span className="visually-hidden">
//                                         Loading...
//                                       </span>
//                                     </div>
//                                     <span>
//                                       <strong>Verifying your license...</strong>
//                                       <br />
//                                       Processing your request, this may take a
//                                       moment.
//                                     </span>
//                                   </div>
//                                 </div>
//                               )}
//                             </>
//                           )}

//                         {/* EXPIRY DATE */}
//                         {lic.verified && (
//                           <>
//                             <Form.Label className="mt-2">
//                               License Expiry Date
//                             </Form.Label>
//                             <Form.Control
//                               type="text"
//                               style={{ backgroundColor: "#E9ECEF" }}
//                               placeholder="Expiry Date"
//                               value={lic.expiry_date}
//                               readOnly
//                             />
//                           </>
//                         )}
//                       </div>
//                     ))}

//                     {licenses.every((lic) => lic.verified) &&
//                       !isAnyLicenseVerifying && (
//                         <Button
//                           className="mb-3"
//                           onClick={() =>
//                             setLicenses([
//                               ...licenses,
//                               {
//                                 license_number: "",
//                                 state: [],
//                                 document: null,
//                                 expiry_date: "",
//                                 verified: false,
//                                 verifying: false,
//                               },
//                             ])
//                           }
//                           disabled={isAnyLicenseVerifying}
//                         >
//                           Add More License
//                         </Button>
//                       )}
//                     {submit && validationsRes.license_numberErr && (
//                       <span className="validations_err" style={errorStyle}>
//                         {validationsRes.license_numberErr}
//                       </span>
//                     )}
//                   </Form.Group>

//                   <Form.Control
//                     type="text"
//                     placeholder="Supervisor's Name (if applicable)"
//                     value={supervisor_name}
//                     onChange={(e) => {
//                       setSupervisorName(e.target.value);
//                     }}
//                   />

//                   <Form.Group
//                     className="mb-3"
//                     controlId="exampleForm.ControlInput3"
//                   >
//                     <div className="uploadBox">
//                       <p>
//                         Please upload your state ID card or state driver license
//                       </p>
//                       <div className="file">
//                         {id_proofs.length > 0 ? (
//                           id_proofs.length == 1 ? (
//                             <label htmlFor="input-file2">
//                               {id_proofs.length} ID selected
//                             </label>
//                           ) : (
//                             <label htmlFor="input-file2">
//                               {id_proofs.length} ID's selected
//                             </label>
//                           )
//                         ) : (
//                           <label htmlFor="input-file2">
//                             <FaCloudUploadAlt /> Upload ID
//                           </label>
//                         )}
//                         <input
//                           id="input-file2"
//                           type="file"
//                           accept=".pdf,.jpg,.jpeg,.png,.heic"
//                           onChange={(e) => {
//                             select_id_proofs(e.target.files);
//                           }}
//                           multiple
//                         />
//                       </div>
//                       <small>
//                         File size of your documents should not exceed 3 MB
//                       </small>
//                     </div>
//                   </Form.Group>
//                   {submit && validationsRes.id_proofsErr && (
//                     <span className="validations_err" style={errorStyle}>
//                       {validationsRes.id_proofsErr}
//                     </span>
//                   )}
//                   <Form.Group
//                     className="mb-4"
//                     controlId="exampleForm.ControlInput3"
//                   >
//                     <Form.Label>HIPAA Compliance</Form.Label>
//                     {["checkbox"].map((type) => (
//                       <div key={`default-${type}`} className="mb-3 termBox">
//                         <Form.Check // prettier-ignore
//                           type={type}
//                           id="1"
//                           checked={termsAndConditions}
//                           label={
//                             <span>
//                               I accept the{" "}
//                               <Link
//                                 to=""
//                                 onClick={(e) => {
//                                   e.preventDefault();
//                                   window.open("/termsofservice");
//                                 }}
//                                 className="linkhip"
//                               >
//                                 terms and conditions
//                               </Link>
//                               {" - "}
//                               <Link
//                                 to=""
//                                 onClick={(e) => {
//                                   e.preventDefault();
//                                   window.open("/hipaa");
//                                 }}
//                                 className="linkhip"
//                               >
//                                 HIPAA
//                               </Link>{" "}
//                               while sharing my details
//                             </span>
//                           }
//                           onClick={() => {
//                             setTermsAndConditions(!termsAndConditions);
//                           }}
//                         />
//                       </div>
//                     ))}
//                   </Form.Group>
//                   <Button
//                     className="btn btn-primary me-3"
//                     onClick={() => {
//                       submitFun();
//                     }}
//                     disabled={!termsAndConditions}
//                   >
//                     Submit
//                   </Button>
//                 </div>
//               </Form>
//             </div>
//           </div>
//         </div>
//       </section>
//       {show_otp_modal && (
//         <Otp_model_for_register
//           show={true}
//           onHide={() => {
//             setShowOtpModal(false);
//           }}
//           verify_type="update_profile"
//           phone_number={custom_phone}
//           register_function={register_function}
//         />
//       )}
//       <Date_model show={showDateModel} />
//     </>
//   );
// };

// export default TherapistRegisteration;

// import React, { useState, useEffect, useContext, useRef } from "react";
// import Image from "react-bootstrap/Image";
// import Form from "react-bootstrap/Form";
// import "react-phone-input-2/lib/style.css";
// import Button from "react-bootstrap/Button";
// import LoginBg from "../../images/newimg/login.jpg";
// import PlaceholderImg from "../../images/placeholder.png";
// import EditIcon from "../../images/edit.svg";
// import {
//   FaChevronDown,
//   FaChevronUp,
//   FaCloudUploadAlt,
//   FaFilePdf,
//   FaTimes,
// } from "react-icons/fa";
// import { toast } from "react-toastify";
// import { ValidationsService } from "../../../utility/services/ValidationsService";
// import ConstConfig from "../../../utility/configs/constConfig";
// import Functions from "../../../utility/services/Functions";
// import ApiService from "../../../utility/services/ApiService";
// import { useNavigate, useLocation, Link } from "react-router-dom";
// import { AuthContext } from "../../../utility/services/AuthContext";
// import { MultiSelect } from "react-multi-select-component";
// import Select from "react-dropdown-select";
// import Calendar from "react-calendar";
// import Modal from "react-bootstrap/Modal";
// import Otp_model_for_register from "../../common/components/Otp_model_for_register";
// import heic2any from "heic2any";

// const TherapistRegisteration = () => {
//   // DATA VARIABLES

//   const location = useLocation();

//   let navigateFrom = location.state != null ? location.state.navigateFrom : "";
//   const isNavigateFromOptScreen = navigateFrom == "otp_screen";
//   let phone = isNavigateFromOptScreen
//     ? location.state != null
//       ? location.state.phone
//       : ""
//     : "";
//   let socialData = !isNavigateFromOptScreen ? location.state.socialData : {};
//   const apple_id =
//     Object.keys(socialData).length > 0 ? socialData.apple_id : "";

//   const facebook_id =
//     Object.keys(socialData).length > 0 ? socialData.facebook_id : "";

//   const [firstName, setFirstName] = useState("");
//   const [lastName, setLastName] = useState("");
//   const [custom_phone, setCustomPhone] = useState("");
//   const [dob, setDob] = useState("");
//   const [date_to_send, setDateToSend] = useState("");
//   const [gender, setGender] = useState("Male");
//   const [email, setEmail] = useState(
//     isNavigateFromOptScreen ? "" : socialData?.email
//   );
//   const [state, setState] = useState([]);
//   const [speciality, setSpeciality] = useState([]);
//   const [profile_img, setProfileImg] = useState("");
//   const [certificates, setCertificates] = useState([]);
//   const [id_proofs, setIdProofs] = useState([]);
//   const [imgPreview, setImgPreview] = useState("");
//   const [speciality_type_id, setSpecialityTypeId] = useState("");
//   const [supervisor_name, setSupervisorName] = useState("");

//   // LOGICAL VARIABLES

//   const [specialityList, setSpecialityList] = useState([]);
//   const [statesList, setStatesList] = useState([]);
//   const [validationsRes, setValidationsRes] = useState({});
//   const [submit, setSubmit] = useState(false);
//   const [showDateModel, setShowDateModel] = useState(false);
//   const [showExpiryDateModel, setShowExpiryDateModel] = useState(false);
//   const [selected_license, setSelectedLicense] = useState({});
//   const [show_otp_modal, setShowOtpModal] = useState(false);
//   const [termsAndConditions, setTermsAndConditions] = useState(false);
//   const [licenses, setLicenses] = useState([
//     {
//       license_number: "",
//       state: [],
//       document: null,
//       expiry_date: "",
//       verified: "not_checked",
//       verifying: false,
//     },
//   ]);
//   const [isAnyLicenseVerifying, setIsAnyLicenseVerifying] = useState(false);

//   const { consoleService, formetDate, calculateAge, fileToBase64 } =
//     Functions();

//   const {
//     get_speciality,
//     get_speciality_types,
//     get_states,
//     register_user,
//     verify_license,
//   } = ApiService();
//   const { setLoading } = useContext(AuthContext);
//   const navigate = useNavigate();

//   const errorStyle = {
//     position: "relative",
//     top: -10,
//   };

//   // USE EFFECT

//   useEffect(() => {
//     if (!navigateFrom)
//       return navigate("/login", {
//         replace: true,
//       });
//     fetch_lists();
//   }, []);

//   useEffect(() => {
//     const spanElement = document.querySelector(".dropdown-heading-value .gray");
//     if (spanElement) {
//       spanElement.textContent = "Select Speciality";
//     }
//   }, [speciality]);

//   useEffect(() => {
//     validationsResFun();
//   }, [
//     firstName,
//     dob,
//     custom_phone,
//     gender,
//     email,
//     speciality,
//     id_proofs,
//     licenses,
//     supervisor_name,
//   ]);

//   // FUNCTIONS

//   function validationsResFun() {
//     setValidationsRes(
//       ValidationsService({
//         firstName,
//         dob,
//         phone: custom_phone,
//         gender,
//         email,
//         speciality,
//         id_proofs,
//         licenses,
//         supervisor_name,
//       })
//     );
//   }

//   const verifyLicense = async (index) => {
//     const updatedLicenses = [...licenses];
//     const license = updatedLicenses[index];

//     // Check for duplicate license numbers
//     const isDuplicate = licenses.some(
//       (lic, i) =>
//         i !== index &&
//         lic.license_number.trim() &&
//         lic.license_number.toUpperCase() ===
//           license.license_number.toUpperCase()
//     );

//     if (isDuplicate) {
//       toast(
//         "This license number is already used. Please enter a different license number.",
//         {
//           position: "top-center",
//           hideProgressBar: true,
//           type: "error",
//         }
//       );
//       return;
//     }

//     license.verifying = true;
//     setIsAnyLicenseVerifying(true);
//     setLicenses([...updatedLicenses]);

//     try {
//       const base64File = await fileToBase64(license.document);
//       const requestData = {
//         license_number: license.license_number,
//         state: license.state[0].label,
//         file: base64File,
//       };

//       const response = await verify_license(requestData);

//       if (response.status === 1) {
//         license.verified = "verified";
//         license.expiry_date = response.data.expiry_date;
//       } else {
//         license.verified = "unverified";
//         toast(response.message || "Verification failed", {
//           position: "top-center",
//           hideProgressBar: true,
//           type: "info",
//           style: {
//             backgroundColor: "#1D7E7C",
//             color: "white",
//           },
//         });
//       }
//     } catch (error) {
//       consoleService("License verification error:", error);
//       license.verified = "unverified";
//       toast("Server error occurred", {
//         position: "top-center",
//         hideProgressBar: true,
//         type: "error",
//       });
//     } finally {
//       license.verifying = false;
//       setIsAnyLicenseVerifying(false);
//       setLicenses([...updatedLicenses]);
//     }
//   };

//   async function fetch_lists() {
//     setLoading(true);
//     try {
//       const res = await get_speciality_types();
//       const states_res = await get_states();
//       if (res.status === 1 && states_res.status === 1) {
//         const modified_states_list = states_res.data.map((item) => {
//           return { label: item.title, value: item._id };
//         });
//         setStatesList(modified_states_list);
//         const typeId = res.data[0]._id;
//         const list_res = await get_speciality(typeId);
//         setSpecialityTypeId(typeId);
//         if (list_res.status == 1) {
//           const modifiedRes = list_res.data.map((item) => {
//             return { label: item.title, value: item._id };
//           });
//           setSpecialityList([...modifiedRes]);

//           if (!isNavigateFromOptScreen) {
//             if (socialData.loginType == "google") {
//               setFirstName(socialData.given_name);
//               setLastName(socialData.family_name);
//             } else if (socialData.loginType == "facebook") {
//               const name = socialData.name.split(" ");
//               setFirstName(name[0]);
//               if (name.length > 1) {
//                 setLastName([name[1]]);
//               }
//             }
//           }

//           setLoading(false);
//         }
//       }
//     } catch (err) {
//       setLoading(false);
//       consoleService("Error in fetch lists function = ", err);
//     }
//   }

//   const select_profile_img = async (files) => {
//     try {
//       if (files.length > 0) {
//         const file = files[0];
//         const imageTypeRegex = /image\/(jpg|jpeg|png|heic)/gm;
//         const isMatch = file.type.match(imageTypeRegex);
//         if (isMatch) {
//           if (file.type === "image/heic" || file.name.endsWith(".heic")) {
//             try {
//               const blob = await heic2any({
//                 blob: file,
//                 toType: "image/jpeg",
//               });
//               const convertedFile = new File(
//                 [blob],
//                 file.name.replace(".heic", ".jpg"),
//                 { type: "image/jpeg" }
//               );
//               setImgPreview(URL.createObjectURL(convertedFile));
//               setProfileImg(convertedFile);
//             } catch (error) {
//               toast(
//                 "Failed to process HEIC image. Please upload a JPG or PNG instead.",
//                 {
//                   position: "top-center",
//                   hideProgressBar: true,
//                   type: "error",
//                 }
//               );
//               return;
//             }
//           } else {
//             setImgPreview(URL.createObjectURL(file));
//             setProfileImg(file);
//           }
//         } else {
//           toast("Please select a file in JPG, PNG, HEIC, or JPEG format.", {
//             position: "top-center",
//             hideProgressBar: true,
//             type: "error",
//           });
//         }
//       }
//     } catch (err) {
//       consoleService("err in select_profile_image =", err);
//     }
//   };

//   const select_certificates = async (files) => {
//     try {
//       const imageTypeRegex = /(application|image)\/(pdf|jpeg|jpg|png|heic)/gm;
//       const vaildDocs = [];
//       for (let i = 0; i < files.length; i++) {
//         const file = files[i];
//         const maxSize = 3 * 1024 * 1024;
//         if (file.size > maxSize)
//           return toast("File size of your documents should not exceed 3 MB.", {
//             position: "top-center",
//             hideProgressBar: true,
//             type: "error",
//           });
//         if (file.type.match(imageTypeRegex)) {
//           if (file.type === "image/heic" || file.name.endsWith(".heic")) {
//             try {
//               const blob = await heic2any({
//                 blob: file,
//                 toType: "image/jpeg",
//               });
//               const convertedFile = new File(
//                 [blob],
//                 file.name.replace(".heic", ".jpg"),
//                 { type: "image/jpeg" }
//               );
//               vaildDocs.push(convertedFile);
//             } catch (error) {
//               toast(
//                 "Failed to process HEIC image. Please upload a JPG or PNG instead.",
//                 {
//                   position: "top-center",
//                   hideProgressBar: true,
//                   type: "error",
//                 }
//               );
//               return;
//             }
//           } else {
//             vaildDocs.push(file);
//           }
//         } else {
//           consoleService("fileType = ", file.type);
//           return toast("You can select only (pdf,jpeg,jpg,png,heic) files.", {
//             position: "top-center",
//             hideProgressBar: true,
//             type: "error",
//           });
//         }
//       }

//       if (vaildDocs.length > 0) {
//         setCertificates(vaildDocs);
//         return;
//       }
//     } catch (err) {
//       consoleService("error in select certificate", err);
//     }
//   };

//   const select_id_proofs = async (files) => {
//     try {
//       const imageTypeRegex = /(application|image)\/(pdf|jpeg|jpg|png|heic)/gm;
//       const vaildDocs = [];
//       for (let i = 0; i < files.length; i++) {
//         const file = files[i];
//         const maxSize = 3 * 1024 * 1024;
//         if (file.size > maxSize)
//           return toast("File size of your documents should not exceed 3 MB.", {
//             position: "top-center",
//             hideProgressBar: true,
//             type: "error",
//           });
//         if (file.type.match(imageTypeRegex)) {
//           if (file.type === "image/heic" || file.name.endsWith(".heic")) {
//             try {
//               const blob = await heic2any({
//                 blob: file,
//                 toType: "image/jpeg",
//               });
//               const convertedFile = new File(
//                 [blob],
//                 file.name.replace(".heic", ".jpg"),
//                 { type: "image/jpeg" }
//               );
//               vaildDocs.push(convertedFile);
//             } catch (error) {
//               toast(
//                 "Failed to process HEIC image. Please upload a JPG or PNG instead.",
//                 {
//                   position: "top-center",
//                   hideProgressBar: true,
//                   type: "error",
//                 }
//               );
//               return;
//             }
//           } else {
//             vaildDocs.push(file);
//           }
//         } else {
//           return toast("You can select only (pdf,jpeg,jpg,png,heic) files.", {
//             position: "top-center",
//             hideProgressBar: true,
//             type: "error",
//           });
//         }
//       }

//       if (vaildDocs.length > 0) {
//         setIdProofs(vaildDocs);
//         return;
//       }
//     } catch (err) {
//       consoleService("error in select proof = ", err);
//     }
//   };

//   const validateLicenses = () => {
//     for (const lic of licenses) {
//       if (
//         !lic.license_number ||
//         !lic.state.length ||
//         !lic.document ||
//         !lic.expiry_date
//       ) {
//         return "All license fields are required";
//       }
//     }
//     return null;
//   };

//   const validateLicensesForExpiryDate = () => {
//     for (const lic of licenses) {
//       if (!lic.license_number || !lic.state.length || !lic.document) {
//         return "All license fields are required";
//       }
//     }
//     return null;
//   };
//   const submitFun = async () => {
//     if (!navigateFrom)
//       return navigate("/login", {
//         replace: true,
//       });
//     let ConditionCheck = false;
//     const isCustomPhoneFound = custom_phone.trim() != "";
//     const isNavigateFromOtpScreen = navigateFrom == "otp_screen";
//     if (isNavigateFromOtpScreen) {
//       if (phone) {
//         ConditionCheck = true;
//       } else {
//         ConditionCheck = false;
//       }
//     } else {
//       if (isCustomPhoneFound && validationsRes.phoneErr)
//         return toast(validationsRes.phoneErr, {
//           position: "top-center",
//           hideProgressBar: true,
//           type: "error",
//         });
//       ConditionCheck = true;
//     }
//     if (!(calculateAge(dob) >= 12))
//       return toast("You must be above 12 years of age to register.", {
//         position: "top-center",
//         hideProgressBar: true,
//         type: "error",
//       });

//     setSubmit(true);
//     const licenseValidationError = validateLicenses();
//     if (licenseValidationError) {
//       toast(licenseValidationError, {
//         position: "top-center",
//         hideProgressBar: true,
//         type: "error",
//       });
//       return;
//     }
//     const currentDate = new Date();
//     currentDate.setHours(0, 0, 0, 0); // Reset time part for accurate date comparison

//     for (const lic of licenses) {
//       const expiryDate = new Date(lic.expiry_date);
//       expiryDate.setHours(0, 0, 0, 0);

//       if (expiryDate <= currentDate) {
//         toast("License expiry date must be in the future.", {
//           position: "top-center",
//           hideProgressBar: true,
//           type: "error",
//         });
//         return;
//       }
//     }

//     if (
//       !validationsRes.firstNameErr &&
//       !validationsRes.dobErr &&
//       !validationsRes.emailErr &&
//       !validationsRes.specialityErr &&
//       !validationsRes.id_proofsErr &&
//       termsAndConditions &&
//       ConditionCheck
//     ) {
//       try {
//         const isPhoneToUpdate = isNavigateFromOptScreen
//           ? false
//           : isCustomPhoneFound
//           ? true
//           : false;
//         if (isPhoneToUpdate) return setShowOtpModal(true);

//         await register_function(phone);
//       } catch (err) {
//         setLoading(false);
//         consoleService("Error in submit function = ", err);
//       }
//     } else {
//       toast("Some fields are missing.", {
//         position: "top-center",
//         hideProgressBar: true,
//         type: "error",
//       });
//     }
//   };

//   const register_function = async (phone_no_to_update) => {
//     try {
//       setLoading(true);
//       const formData = new FormData();
//       formData.append("first_name", firstName);
//       formData.append("last_name", lastName);
//       formData.append("dob", date_to_send);
//       formData.append("email", email);
//       formData.append("apple_id", apple_id);
//       formData.append("facebook_id", facebook_id);
//       formData.append("gender", gender);
//       formData.append("speciality_type_id", speciality_type_id);
//       formData.append("supervisor_name", supervisor_name);
//       formData.append("terms", termsAndConditions);
//       id_proofs.forEach((item) => {
//         formData.append("id_proof", item);
//       });

//       // Send licenses array instead of single license_number
//       const licensesData = licenses.map((lic, index) => ({
//         license_number: lic.license_number,
//         state: lic.state.length > 0 ? lic.state[0].value : "",
//         file_path: "",
//         expiry_date: lic.expiry_date,
//         verified: lic.verified,
//       }));
//       formData.append("licenses", JSON.stringify(licensesData));

//       // Append license documents
//       licenses.forEach((lic, index) => {
//         if (lic.document) {
//           formData.append(`license_document_${index}`, lic.document);
//         }
//       });

//       formData.append("role", "Therapist");
//       formData.append("profile_img", profile_img);
//       formData.append("phone", phone_no_to_update);
//       formData.append(
//         "speciality_id",
//         JSON.stringify(speciality.map((item) => item.value))
//       );

//       const res = await register_user(formData);
//       if (res.status === 1) {
//         window.dataLayer = window.dataLayer || [];
//         window.dataLayer.push({
//           event: "therapist_registration",
//           email: email,
//           phone: phone_no_to_update,
//         });
//         clearFields();
//         setLoading(false);
//         setSubmit(false);

//         navigate("/therapistcompleteprofile", {
//           state: res.data._id,
//           replace: true,
//         });
//       } else {
//         setLoading(false);
//         toast(res.message, {
//           position: "top-center",
//           hideProgressBar: true,
//           type: "error",
//         });
//       }
//     } catch (err) {
//       consoleService("error in register_function ", err);
//     }
//   };

//   function clearFields() {
//     setFirstName("");
//     setLastName("");
//     setDob("");
//     setCustomPhone("");
//     setDateToSend("");
//     setGender("Male");
//     setEmail("");
//     setState("");
//     setSpeciality("");
//     setProfileImg("");
//     setCertificates([]);
//     setIdProofs([]);
//     setImgPreview([]);
//     setSpecialityTypeId("");
//     phone = "";
//   }

//   function Date_model(props) {
//     const [selectedDate, setSelectedDate] = useState(
//       dob ? new Date(dob) : new Date(1940, 0, 1)
//     );
//     return (
//       <Modal
//         {...props}
//         size="md"
//         className="modalregs"
//         aria-labelledby="contained-modal-title-vcenter"
//         centered
//         onHide={() => {
//           setSelectedDate(new Date(dob));
//           setShowDateModel(false);
//         }}
//       >
//         <Modal.Body className="text-left">
//           <section className="pb-4 pt-2 packagebox packagebox_book">
//             <div className="container">
//               <div className="row">
//                 <div className="col-md-12">
//                   <h2>Select Date</h2>
//                   <Calendar
//                     onChange={(date) => {
//                       setSelectedDate(new Date(date));
//                     }}
//                     value={selectedDate}
//                     minDate={new Date(1940, 0, 1)}
//                     maxDate={new Date()}
//                     tileClassName="calendar_tiles"
//                   />
//                 </div>
//               </div>
//             </div>
//           </section>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button
//             as={Link}
//             onClick={(e) => {
//               e.preventDefault();
//               setDob(
//                 `${selectedDate.getFullYear()}/${
//                   selectedDate.getMonth() + 1
//                 }/${selectedDate.getDate()}`
//               );
//               setDateToSend(selectedDate);
//               setShowDateModel(false);
//             }}
//           >
//             Done
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     );
//   }
//   function Expiry_Date_model(props) {
//     const lic = selected_license;
//     const index = lic.index;
//     const [selectedDate, setSelectedDate] = useState(
//       lic.expiry_date
//         ? new Date(lic.expiry_date).toISOString().split("T")[0]
//         : new Date()
//     );
//     return (
//       <Modal
//         {...props}
//         size="md"
//         className="modalregs"
//         aria-labelledby="contained-modal-title-vcenter"
//         centered
//         onHide={() => {
//           setSelectedDate(new Date(lic.expiry_date));
//           setShowExpiryDateModel(false);
//         }}
//       >
//         <Modal.Body className="text-left">
//           <section className="pb-4 pt-2 packagebox packagebox_book">
//             <div className="container">
//               <div className="row">
//                 <div className="col-md-12">
//                   <h2>Select Date</h2>
//                   <Calendar
//                     onChange={(date) => {
//                       setSelectedDate(new Date(date));
//                     }}
//                     value={selectedDate}
//                     minDate={new Date()}
//                     tileClassName="calendar_tiles"
//                   />
//                 </div>
//               </div>
//             </div>
//           </section>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button
//             as={Link}
//             onClick={(e) => {
//               e.preventDefault();
//               const updated = [...licenses];
//               const utcDate = new Date(
//                 Date.UTC(
//                   selectedDate.getFullYear(),
//                   selectedDate.getMonth(),
//                   selectedDate.getDate()
//                 )
//               );
//               updated[index].expiry_date = utcDate.toISOString().split("T")[0];
//               setLicenses(updated);
//               setShowExpiryDateModel(false);
//             }}
//           >
//             Done
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     );
//   }

//   return (
//     <>
//       <section
//         className="loginBg"
//         style={{ backgroundImage: `url(${LoginBg})` }}
//       >
//         <div className="container">
//           <div className="row">
//             <div className="col-md-12">
//               <Form>
//                 <div className="loginBox loginUpdateBox">
//                   <div className="userImg">
//                     <Image
//                       src={imgPreview ? imgPreview : PlaceholderImg}
//                       className="userImage"
//                       alt=""
//                     />
//                     <div>
//                       <Image src={EditIcon} className="editIcon" alt="" />
//                       <input
//                         type="file"
//                         accept="image/jpg, image/jpeg , image/heic , image/png"
//                         className="edit_img"
//                         multiple={false}
//                         onChange={(e) => {
//                           select_profile_img(e.target.files);
//                         }}
//                       />
//                     </div>
//                   </div>
//                   <Form.Label>Personal Information</Form.Label>
//                   <Form.Control
//                     type="text"
//                     placeholder="First Name"
//                     value={firstName}
//                     onChange={(e) => {
//                       setFirstName(e.target.value);
//                     }}
//                   />
//                   {submit && validationsRes.firstNameErr && (
//                     <span className="validations_err" style={errorStyle}>
//                       {validationsRes.firstNameErr}
//                     </span>
//                   )}
//                   <Form.Control
//                     type="text"
//                     placeholder="Last Name"
//                     value={lastName}
//                     onChange={(e) => {
//                       setLastName(e.target.value);
//                     }}
//                   />
//                   <Form.Control
//                     className="mb-3"
//                     type="text"
//                     placeholder="D.O.B."
//                     value={dob && formetDate(dob)}
//                     onClick={() => {
//                       setShowDateModel(true);
//                     }}
//                   />
//                   {submit && validationsRes.dobErr && (
//                     <span className="validations_err" style={errorStyle}>
//                       {validationsRes.dobErr}
//                     </span>
//                   )}
//                   <Form.Group
//                     className="mb-3"
//                     controlId="exampleForm.ControlInput3"
//                   >
//                     <Form.Label>What is your gender?</Form.Label>
//                     {["radio"].map((type) => (
//                       <div key={`default-${type}`} className="boxFlex">
//                         <Form.Check // prettier-ignore
//                           type={type}
//                           id="g1"
//                           label="Male"
//                           name="gender"
//                           checked={gender == "Male"}
//                           onClick={() => {
//                             setGender("Male");
//                           }}
//                         />
//                         <Form.Check // prettier-ignore
//                           type={type}
//                           id="g2"
//                           label="Female"
//                           name="gender"
//                           checked={gender == "Female"}
//                           onClick={() => {
//                             setGender("Female");
//                           }}
//                         />
//                         <Form.Check // prettier-ignore
//                           type={type}
//                           id="g3"
//                           label="Unspecified"
//                           name="gender"
//                           checked={gender == "Unspecified"}
//                           onClick={() => {
//                             setGender("Unspecified");
//                           }}
//                         />
//                       </div>
//                     ))}
//                   </Form.Group>
//                   <Form.Control
//                     type="text"
//                     placeholder="Email Address"
//                     value={email}
//                     onChange={(e) => {
//                       (isNavigateFromOptScreen || apple_id.trim()) &&
//                         setEmail(e.target.value);
//                     }}
//                   />
//                   {submit && validationsRes.emailErr && (
//                     <span className="validations_err" style={errorStyle}>
//                       {validationsRes.emailErr}
//                     </span>
//                   )}
//                   {!phone && (
//                     <Form.Group
//                       className="mb-3"
//                       controlId="exampleForm.ControlInput2"
//                     >
//                       <div className="pbox register_pb_box">
//                         <div className="callb">
//                           US{" "}
//                           <svg
//                             width="12"
//                             height="8"
//                             viewBox="0 0 12 8"
//                             fill="none"
//                             x
//                           >
//                             <path
//                               d="M1 1.5L6 6.5L11 1.5"
//                               stroke="#212529"
//                               stroke-width="1.66667"
//                               stroke-linecap="round"
//                               stroke-linejoin="round"
//                             />
//                           </svg>
//                           <span
//                             style={{
//                               color: !custom_phone.trim() ? "#929fa4" : null,
//                             }}
//                           >
//                             +1
//                           </span>
//                         </div>
//                         <Form.Control
//                           type="text"
//                           className="register_phone_input"
//                           value={custom_phone}
//                           onChange={(e) => {
//                             const numericValue = e.target.value.replace(
//                               /[^0-9]/g,
//                               ""
//                             );
//                             setCustomPhone(numericValue);
//                           }}
//                           onKeyDown={(e) => {
//                             if (e.key == "Enter") {
//                               e.preventDefault();
//                             }
//                           }}
//                           placeholder="(555) 000-0000"
//                         />
//                       </div>
//                     </Form.Group>
//                   )}

//                   <Form.Group
//                     className="mb-3"
//                     controlId="exampleForm.ControlInput3"
//                   >
//                     <MultiSelect
//                       options={specialityList}
//                       value={speciality}
//                       onChange={setSpeciality}
//                       labelledBy="Select Specialty"
//                       className="checkBoxNew"
//                     />
//                   </Form.Group>
//                   {submit && validationsRes.specialityErr && (
//                     <span className="validations_err" style={errorStyle}>
//                       {validationsRes.specialityErr}
//                     </span>
//                   )}
//                   <Form.Label>Licensing Information</Form.Label>
//                   <Form.Group
//                     className="mt-3"
//                     controlId="exampleForm.ControlInput3"
//                   >
//                     {licenses.map((lic, index) => (
//                       <div
//                         key={index}
//                         className="licenseBox shadow p-3 mt-3 mb-3 bg-body rounded position-relative"
//                       >
//                         <div className="d-flex align-items-center  pb-1">
//                           <p className="mb-0 me-2">License #{index + 1}</p>
//                           <div className="ms-auto d-flex align-items-center me-3">
//                             {lic.verified === "verified" && (
//                               <span
//                                 className="badge bg-success"
//                                 style={{ fontSize: "12px" }}
//                               >
//                                 Verified
//                               </span>
//                             )}
//                             {lic.verified === "unverified" && (
//                               <>
//                                 <span
//                                   className="badge bg-danger"
//                                   style={{ fontSize: "12px" }}
//                                 >
//                                   Unverified
//                                 </span>
//                                 <span
//                                   style={{
//                                     cursor: "pointer",
//                                     fontSize: "13px",
//                                     color: "#1D7E7C",
//                                     textDecoration: "underline",
//                                     fontWeight: "bold",
//                                     marginLeft: "5px",
//                                   }}
//                                   onClick={() => {
//                                     const updated = [...licenses];
//                                     updated[index] = {
//                                       ...updated[index],
//                                       verified: "not_checked",
//                                     };
//                                     setLicenses(updated);
//                                     document.getElementById(
//                                       `license-file-${index}`
//                                     ).value = null;
//                                   }}
//                                 >
//                                   Try again
//                                 </span>
//                               </>
//                             )}
//                           </div>
//                         </div>
//                         {/* REMOVE BUTTON */}
//                         {licenses.length > 1 && (
//                           <FaTimes
//                             className="position-absolute"
//                             style={{
//                               top: 10,
//                               right: 10,
//                               cursor: isAnyLicenseVerifying
//                                 ? "not-allowed"
//                                 : "pointer",
//                               color: "red",
//                               opacity: isAnyLicenseVerifying ? 0.5 : 1,
//                             }}
//                             onClick={() => {
//                               if (!isAnyLicenseVerifying) {
//                                 const updated = [...licenses];
//                                 updated.splice(index, 1);
//                                 setLicenses(updated);
//                               }
//                             }}
//                           />
//                         )}

//                         <Form.Control
//                           type="text"
//                           placeholder="License Number"
//                           value={lic.license_number}
//                           onChange={(e) => {
//                             if (
//                               lic.verified === "not_checked" &&
//                               !isAnyLicenseVerifying
//                             ) {
//                               const updated = [...licenses];
//                               updated[index].license_number =
//                                 e.target.value.toUpperCase();
//                               setLicenses(updated);
//                             }
//                           }}
//                           disabled={
//                             lic.verified !== "not_checked" ||
//                             isAnyLicenseVerifying
//                           }
//                           style={{
//                             textTransform: lic.license_number
//                               ? "uppercase"
//                               : "none",
//                           }}
//                         />

//                         <Select
//                           placeholder="Select State"
//                           className={` ${
//                             lic.verified !== "not_checked" ||
//                             isAnyLicenseVerifying
//                               ? "disabledLicenseSelector"
//                               : ""
//                           }`}
//                           options={statesList}
//                           values={lic.state}
//                           onChange={(value) => {
//                             if (
//                               lic.verified === "not_checked" &&
//                               !isAnyLicenseVerifying
//                             ) {
//                               const updated = [...licenses];
//                               updated[index].state = value;
//                               setLicenses(updated);
//                             }
//                           }}
//                           multi={false}
//                           disabled={
//                             lic.verified !== "not_checked" ||
//                             isAnyLicenseVerifying
//                           }
//                           style={{
//                             color:
//                               lic.verified !== "not_checked"
//                                 ? "#212529"
//                                 : undefined,

//                             borderColor:
//                               lic.verified !== "not_checked"
//                                 ? "#E9ECEF"
//                                 : undefined,
//                             opacity:
//                               lic.verified !== "not_checked" ? 1 : undefined,
//                             backgroundColor:
//                               lic.verified !== "not_checked"
//                                 ? "#E9ECEF"
//                                 : undefined,
//                           }}
//                           dropdownHandleRenderer={({ state }) => (
//                             <span
//                               style={{
//                                 color:
//                                   lic.verified !== "not_checked"
//                                     ? "#212529"
//                                     : undefined,
//                                 opacity:
//                                   lic.verified !== "not_checked"
//                                     ? 0
//                                     : undefined,
//                               }}
//                             >
//                               {state.dropdown ? (
//                                 <FaChevronUp />
//                               ) : (
//                                 <FaChevronDown />
//                               )}
//                             </span>
//                           )}
//                         />

//                         {/* UPLOAD BOX */}
//                         <div className="uploadBox mt-3">
//                           <p>Please upload proof of license certification</p>
//                           <div
//                             className="file"
//                             style={{
//                               position: "relative",
//                               cursor:
//                                 isAnyLicenseVerifying ||
//                                 lic.verified !== "not_checked"
//                                   ? "not-allowed"
//                                   : "pointer",
//                             }}
//                             onClick={() => {
//                               if (
//                                 lic.verified === "not_checked" &&
//                                 !isAnyLicenseVerifying
//                               ) {
//                                 const fileInput = document.getElementById(
//                                   `license-file-${index}`
//                                 );
//                                 if (fileInput) fileInput.value = null;
//                                 document
//                                   .getElementById(`license-file-${index}`)
//                                   .click();
//                               }
//                             }}
//                           >
//                             {licenses[index].document ? (
//                               licenses[index].document.type.includes(
//                                 "image"
//                               ) ? (
//                                 <img
//                                   src={URL.createObjectURL(
//                                     licenses[index].document
//                                   )}
//                                   alt="preview"
//                                   style={{
//                                     width: "100%",
//                                     height: "150px",
//                                     objectFit: "contain",
//                                     border: "1px solid #ccc",
//                                   }}
//                                 />
//                               ) : (
//                                 <div
//                                   style={{
//                                     width: "100%",
//                                     height: "150px",
//                                     border: "1px solid #ccc",
//                                     display: "flex",
//                                     alignItems: "center",
//                                     justifyContent: "center",
//                                     flexDirection: "column",
//                                   }}
//                                 >
//                                   <FaFilePdf size={40} color="red" />
//                                   <p style={{ fontSize: "12px", marginTop: 5 }}>
//                                     {licenses[index].document.name}
//                                   </p>
//                                 </div>
//                               )
//                             ) : (
//                               <span
//                                 className="select_license_document_box"
//                                 htmlFor={`license-file-${index}`}
//                               >
//                                 <FaCloudUploadAlt /> Upload document
//                               </span>
//                             )}
//                             <input
//                               id={`license-file-${index}`}
//                               type="file"
//                               accept=".pdf,.jpg,.jpeg,.png,.heic"
//                               style={{ display: "none" }}
//                               onChange={async (e) => {
//                                 if (
//                                   lic.verified === "not_checked" &&
//                                   !isAnyLicenseVerifying
//                                 ) {
//                                   const file = e.target.files[0];
//                                   const updated = [...licenses];

//                                   if (!file) {
//                                     updated[index].document = null;
//                                     setLicenses(updated);
//                                     return;
//                                   }

//                                   const validTypes = [
//                                     "image/jpeg",
//                                     "image/png",
//                                     "image/jpg",
//                                     "application/pdf",
//                                     "image/heic",
//                                   ];
//                                   if (!validTypes.includes(file.type)) {
//                                     toast(
//                                       "Invalid file type. Only JPG, PNG, PDF, HEIC allowed",
//                                       {
//                                         position: "top-center",
//                                         hideProgressBar: true,
//                                         type: "error",
//                                       }
//                                     );
//                                     updated[index].document = null;
//                                     setLicenses(updated);
//                                     return;
//                                   }

//                                   if (file.size > 10 * 1024 * 1024) {
//                                     toast("File size exceeds 10MB limit", {
//                                       position: "top-center",
//                                       hideProgressBar: true,
//                                       type: "error",
//                                     });
//                                     updated[index].document = null;
//                                     setLicenses(updated);
//                                     return;
//                                   }

//                                   if (
//                                     file.type === "image/heic" ||
//                                     file.name.endsWith(".heic")
//                                   ) {
//                                     try {
//                                       const blob = await heic2any({
//                                         blob: file,
//                                         toType: "image/jpeg",
//                                       });
//                                       const convertedFile = new File(
//                                         [blob],
//                                         file.name.replace(".heic", ".jpg"),
//                                         { type: "image/jpeg" }
//                                       );
//                                       updated[index].document = convertedFile;
//                                     } catch (error) {
//                                       toast(
//                                         "Failed to process HEIC image. Please upload a JPG or PNG instead.",
//                                         {
//                                           position: "top-center",
//                                           hideProgressBar: true,
//                                           type: "error",
//                                         }
//                                       );
//                                       updated[index].document = null;
//                                       setLicenses(updated);
//                                       return;
//                                     }
//                                   } else {
//                                     updated[index].document = file;
//                                   }

//                                   setLicenses(updated);
//                                 }
//                               }}
//                             />
//                           </div>
//                           <small>
//                             File size of your documents should not exceed 10 MB
//                           </small>
//                         </div>

//                         {/* EXPIRY DATE */}
//                         {(lic?.verified !== "not_checked" ||
//                           (submit &&
//                             (!lic?.expiry_date ||
//                               lic?.verified == "not_checked"))) && (
//                           <div className="mt-3">
//                             <Form.Label>License Expiry Date</Form.Label>

//                             <Form.Control
//                               type="text"
//                               value={
//                                 lic?.expiry_date
//                                   ? new Date(lic.expiry_date)
//                                       .toISOString()
//                                       .split("T")[0]
//                                   : ""
//                               }
//                               placeholder="Expiry Date"
//                               min={new Date().toISOString().split("T")[0]}
//                               onClick={(e) => {
//                                 setSelectedLicense({ ...lic, index });
//                                 setShowExpiryDateModel(true);
//                               }}
//                               disabled={
//                                 (lic.verifying ||
//                                   isAnyLicenseVerifying ||
//                                   lic.verified !== "not_checked") &&
//                                 lic?.expiry_date
//                               }
//                             />
//                             {submit && !lic?.expiry_date && (
//                               <span
//                                 className="validations_err"
//                                 style={errorStyle}
//                               >
//                                 This field is required
//                               </span>
//                             )}
//                           </div>
//                         )}

//                         {/* VERIFY BUTTON */}
//                         {!["verified", "verifying", "unverified"].includes(
//                           lic.verified
//                         ) &&
//                           validateLicensesForExpiryDate() == null && (
//                             <>
//                               <Button
//                                 className="mt-2"
//                                 onClick={() => verifyLicense(index)}
//                                 disabled={isAnyLicenseVerifying}
//                               >
//                                 {lic.verifying ? "Verifying..." : "Verify"}
//                               </Button>
//                               {lic.verifying && (
//                                 <div
//                                   className="mt-2 p-2"
//                                   style={{
//                                     backgroundColor: "#e3f2fd",
//                                     border: "1px solid #1D7E7C",
//                                     borderRadius: "5px",
//                                     fontSize: "14px",
//                                     color: "#1A3D3C",
//                                   }}
//                                 >
//                                   <div className="d-flex align-items-center">
//                                     <div
//                                       className="spinner-border spinner-border-sm me-2"
//                                       role="status"
//                                     >
//                                       <span className="visually-hidden">
//                                         Loading...
//                                       </span>
//                                     </div>
//                                     <span>
//                                       <strong>Verifying your license...</strong>
//                                       <br />
//                                       Processing your request, this may take a
//                                       moment.
//                                     </span>
//                                   </div>
//                                 </div>
//                               )}
//                             </>
//                           )}
//                       </div>
//                     ))}

//                     {licenses.every((lic) => lic.verified !== "not_checked") &&
//                       !isAnyLicenseVerifying && (
//                         <Button
//                           className="mb-3"
//                           onClick={() =>
//                             setLicenses([
//                               ...licenses,
//                               {
//                                 license_number: "",
//                                 state: [],
//                                 document: null,
//                                 expiry_date: "",
//                                 verified: "not_checked",
//                                 verifying: false,
//                               },
//                             ])
//                           }
//                           disabled={isAnyLicenseVerifying}
//                           style={{
//                             whiteSpace: "nowrap",
//                             textAlign: "center",
//                             minWidth: "200px",
//                             width: "auto",
//                           }}
//                         >
//                           Add More License
//                         </Button>
//                       )}
//                     {submit && validationsRes.licensesErr && (
//                       <span className="validations_err" style={errorStyle}>
//                         {validationsRes.licensesErr}
//                       </span>
//                     )}
//                   </Form.Group>

//                   <Form.Control
//                     type="text"
//                     placeholder="Supervisor's Name (if applicable)"
//                     value={supervisor_name}
//                     onChange={(e) => {
//                       setSupervisorName(e.target.value);
//                     }}
//                   />

//                   <Form.Group
//                     className="mb-3"
//                     controlId="exampleForm.ControlInput3"
//                   >
//                     <div className="uploadBox">
//                       <p>
//                         Please upload your state ID card or state driver license
//                       </p>
//                       <div className="file">
//                         {id_proofs.length > 0 ? (
//                           id_proofs.length == 1 ? (
//                             <label htmlFor="input-file2">
//                               {id_proofs.length} ID selected
//                             </label>
//                           ) : (
//                             <label htmlFor="input-file2">
//                               {id_proofs.length} ID's selected
//                             </label>
//                           )
//                         ) : (
//                           <label htmlFor="input-file2">
//                             <FaCloudUploadAlt /> Upload ID
//                           </label>
//                         )}
//                         <input
//                           id="input-file2"
//                           type="file"
//                           accept=".pdf,.jpg,.jpeg,.png,.heic"
//                           onChange={(e) => {
//                             select_id_proofs(e.target.files);
//                           }}
//                           multiple
//                         />
//                       </div>
//                       <small>
//                         File size of your documents should not exceed 3 MB
//                       </small>
//                     </div>
//                   </Form.Group>
//                   {submit && validationsRes.id_proofsErr && (
//                     <span className="validations_err" style={errorStyle}>
//                       {validationsRes.id_proofsErr}
//                     </span>
//                   )}
//                   <Form.Group
//                     className="mb-4"
//                     controlId="exampleForm.ControlInput3"
//                   >
//                     <Form.Label>HIPAA Compliance</Form.Label>
//                     {["checkbox"].map((type) => (
//                       <div key={`default-${type}`} className="mb-3 termBox">
//                         <Form.Check // prettier-ignore
//                           type={type}
//                           id="1"
//                           checked={termsAndConditions}
//                           label={
//                             <span>
//                               I accept the{" "}
//                               <Link
//                                 to=""
//                                 onClick={(e) => {
//                                   e.preventDefault();
//                                   window.open("/termsofservice");
//                                 }}
//                                 className="linkhip"
//                               >
//                                 terms and conditions
//                               </Link>
//                               {" - "}
//                               <Link
//                                 to=""
//                                 onClick={(e) => {
//                                   e.preventDefault();
//                                   window.open("/hipaa");
//                                 }}
//                                 className="linkhip"
//                               >
//                                 HIPAA
//                               </Link>{" "}
//                               while sharing my details
//                             </span>
//                           }
//                           onClick={() => {
//                             setTermsAndConditions(!termsAndConditions);
//                           }}
//                         />
//                       </div>
//                     ))}
//                   </Form.Group>
//                   <Button
//                     className="btn btn-primary me-3"
//                     onClick={() => {
//                       submitFun();
//                     }}
//                     disabled={!termsAndConditions}
//                   >
//                     Submit
//                   </Button>
//                 </div>
//               </Form>
//             </div>
//           </div>
//         </div>
//       </section>
//       {show_otp_modal && (
//         <Otp_model_for_register
//           show={true}
//           onHide={() => {
//             setShowOtpModal(false);
//           }}
//           verify_type="update_profile"
//           phone_number={custom_phone}
//           register_function={register_function}
//         />
//       )}
//       <Date_model show={showDateModel} />
//       <Expiry_Date_model show={showExpiryDateModel} />
//     </>
//   );
// };

// export default TherapistRegisteration;

// // import React, { useState, useEffect, useContext, useRef } from "react";
// // import Image from "react-bootstrap/Image";
// // import Form from "react-bootstrap/Form";
// // import "react-phone-input-2/lib/style.css";
// // import Button from "react-bootstrap/Button";
// // import LoginBg from "../../images/newimg/login.jpg";
// // import PlaceholderImg from "../../images/placeholder.png";
// // import EditIcon from "../../images/edit.svg";
// // import {
// //   FaChevronDown,
// //   FaChevronUp,
// //   FaCloudUploadAlt,
// //   FaFilePdf,
// //   FaTimes,
// // } from "react-icons/fa";
// // import { toast } from "react-toastify";
// // import { ValidationsService } from "../../../utility/services/ValidationsService";
// // import ConstConfig from "../../../utility/configs/constConfig";
// // import Functions from "../../../utility/services/Functions";
// // import ApiService from "../../../utility/services/ApiService";
// // import { useNavigate, useLocation, Link } from "react-router-dom";
// // import { AuthContext } from "../../../utility/services/AuthContext";
// // import { MultiSelect } from "react-multi-select-component";
// // import Select from "react-dropdown-select";
// // import Calendar from "react-calendar";
// // import Modal from "react-bootstrap/Modal";
// // import Otp_model_for_register from "../../common/components/Otp_model_for_register";
// // import heic2any from "heic2any";

// // const TherapistRegisteration = () => {
// //   // DATA VARIABLES

// //   const location = useLocation();

// //   let navigateFrom = location.state != null ? location.state.navigateFrom : "";
// //   const isNavigateFromOptScreen = navigateFrom == "otp_screen";
// //   let phone = isNavigateFromOptScreen
// //     ? location.state != null
// //       ? location.state.phone
// //       : ""
// //     : "";
// //   let socialData = !isNavigateFromOptScreen ? location.state.socialData : {};
// //   const apple_id =
// //     Object.keys(socialData).length > 0 ? socialData.apple_id : "";

// //   const facebook_id =
// //     Object.keys(socialData).length > 0 ? socialData.facebook_id : "";

// //   const [firstName, setFirstName] = useState("");
// //   const [lastName, setLastName] = useState("");
// //   const [custom_phone, setCustomPhone] = useState("");
// //   const [dob, setDob] = useState("");
// //   const [date_to_send, setDateToSend] = useState("");
// //   const [gender, setGender] = useState("Male");
// //   const [email, setEmail] = useState(
// //     isNavigateFromOptScreen ? "" : socialData?.email
// //   );
// //   const [state, setState] = useState([]);
// //   const [speciality, setSpeciality] = useState([]);
// //   const [profile_img, setProfileImg] = useState("");
// //   const [certificates, setCertificates] = useState([]);
// //   const [id_proofs, setIdProofs] = useState([]);
// //   const [imgPreview, setImgPreview] = useState("");
// //   const [speciality_type_id, setSpecialityTypeId] = useState("");
// //   const [license_number, setLicenseNumber] = useState("");
// //   const [supervisor_name, setSupervisorName] = useState("");

// //   // LOGICAL VARIABLES

// //   const [specialityList, setSpecialityList] = useState([]);
// //   const [statesList, setStatesList] = useState([]);
// //   const [validationsRes, setValidationsRes] = useState({});
// //   const [submit, setSubmit] = useState(false);
// //   const [showDateModel, setShowDateModel] = useState(false);
// //   const [show_otp_modal, setShowOtpModal] = useState(false);
// //   const [termsAndConditions, setTermsAndConditions] = useState(false);
// //   const [licenses, setLicenses] = useState([
// //     {
// //       license_number: "",
// //       state: [],
// //       document: null,
// //       expiry_date: "",
// //       verified: false,
// //       verifying: false,
// //     },
// //   ]);
// //   const [isAnyLicenseVerifying, setIsAnyLicenseVerifying] = useState(false);

// //   const { consoleService, formetDate, calculateAge, fileToBase64 } =
// //     Functions();

// //   const {
// //     get_speciality,
// //     get_speciality_types,
// //     get_states,
// //     register_user,
// //     verify_license,
// //   } = ApiService();
// //   const { setLoading } = useContext(AuthContext);
// //   const navigate = useNavigate();

// //   const errorStyle = {
// //     position: "relative",
// //     top: -10,
// //   };

// //   // USE EFFECT

// //   useEffect(() => {
// //     if (!navigateFrom)
// //       return navigate("/login", {
// //         replace: true,
// //       });
// //     fetch_lists();
// //   }, []);

// //   useEffect(() => {
// //     const spanElement = document.querySelector(".dropdown-heading-value .gray");
// //     if (spanElement) {
// //       spanElement.textContent = "Select Speciality";
// //     }
// //   }, [speciality]);

// //   useEffect(() => {
// //     validationsResFun();
// //   }, [
// //     firstName,
// //     dob,
// //     custom_phone,
// //     gender,
// //     email,
// //     speciality,
// //     id_proofs,
// //     licenses,
// //     supervisor_name,
// //   ]);

// //   // FUNCTIONS

// //   function validationsResFun() {
// //     setValidationsRes(
// //       ValidationsService({
// //         firstName,
// //         dob,
// //         phone: custom_phone,
// //         gender,
// //         email,
// //         speciality,
// //         id_proofs,
// //         licenses,
// //         supervisor_name,
// //       })
// //     );
// //   }

// //   const canShowVerify = licenses.some(
// //     (lic) => lic.license_number && lic.state.length > 0 && lic.document
// //   );

// //   const verifyLicense = async (index) => {
// //     const updatedLicenses = [...licenses];
// //     const license = updatedLicenses[index];

// //     // Check for duplicate license numbers in all licenses (verified or not)
// //     const isDuplicate = licenses.some(
// //       (lic, i) =>
// //         i !== index &&
// //         lic.license_number.trim() &&
// //         lic.license_number.toUpperCase() ===
// //           license.license_number.toUpperCase()
// //     );

// //     if (isDuplicate) {
// //       toast(
// //         "This license number is already used. Please enter a different license number.",
// //         {
// //           position: "top-center",
// //           hideProgressBar: true,
// //           type: "error",
// //         }
// //       );
// //       return;
// //     }

// //     // Start loading
// //     license.verifying = true;
// //     setIsAnyLicenseVerifying(true);
// //     setLicenses([...updatedLicenses]);

// //     try {
// //       // Convert file to base64
// //       const base64File = await fileToBase64(license.document);

// //       const requestData = {
// //         license_number: license.license_number,
// //         state: license.state[0].label, // Send state name/code
// //         file: base64File,
// //       };

// //       const response = await verify_license(requestData);

// //       if (response.status === 1) {
// //         license.verified = true;
// //         license.expiry_date = response.data.expiry_date;
// //       } else {
// //         license.verified = false;
// //         toast(response.message || "Verification failed", {
// //           position: "top-center",
// //           hideProgressBar: true,
// //           type: "error",
// //         });
// //       }
// //     } catch (error) {
// //       consoleService("License verification error:", error);
// //       license.verified = false;
// //       toast("Server error occurred", {
// //         position: "top-center",
// //         hideProgressBar: true,
// //         type: "error",
// //       });
// //     } finally {
// //       // Stop loading
// //       license.verifying = false;
// //       setIsAnyLicenseVerifying(false);
// //       setLicenses([...updatedLicenses]);
// //     }
// //   };

// //   async function fetch_lists() {
// //     setLoading(true);
// //     try {
// //       const res = await get_speciality_types();
// //       const states_res = await get_states();
// //       if (res.status === 1 && states_res.status === 1) {
// //         const modified_states_list = states_res.data.map((item) => {
// //           return { label: item.title, value: item._id };
// //         });
// //         setStatesList(modified_states_list);
// //         const typeId = res.data[0]._id;
// //         const list_res = await get_speciality(typeId);
// //         setSpecialityTypeId(typeId);
// //         if (list_res.status == 1) {
// //           const modifiedRes = list_res.data.map((item) => {
// //             return { label: item.title, value: item._id };
// //           });
// //           setSpecialityList([...modifiedRes]);

// //           if (!isNavigateFromOptScreen) {
// //             if (socialData.loginType == "google") {
// //               setFirstName(socialData.given_name);
// //               setLastName(socialData.family_name);
// //             } else if (socialData.loginType == "facebook") {
// //               const name = socialData.name.split(" ");
// //               setFirstName(name[0]);
// //               if (name.length > 1) {
// //                 setLastName([name[1]]);
// //               }
// //             }
// //           }

// //           setLoading(false);
// //         }
// //       }
// //     } catch (err) {
// //       setLoading(false);
// //       consoleService("Error in fetch lists function = ", err);
// //     }
// //   }

// //   const select_profile_img = async (files) => {
// //     try {
// //       if (files.length > 0) {
// //         const file = files[0];
// //         const imageTypeRegex = /image\/(jpg|jpeg|png|heic)/gm;
// //         const isMatch = file.type.match(imageTypeRegex);
// //         if (isMatch) {
// //           if (file.type === "image/heic" || file.name.endsWith(".heic")) {
// //             try {
// //               const blob = await heic2any({
// //                 blob: file,
// //                 toType: "image/jpeg",
// //               });
// //               const convertedFile = new File(
// //                 [blob],
// //                 file.name.replace(".heic", ".jpg"),
// //                 { type: "image/jpeg" }
// //               );
// //               setImgPreview(URL.createObjectURL(convertedFile));
// //               setProfileImg(convertedFile);
// //             } catch (error) {
// //               toast(
// //                 "Failed to process HEIC image. Please upload a JPG or PNG instead.",
// //                 {
// //                   position: "top-center",
// //                   hideProgressBar: true,
// //                   type: "error",
// //                 }
// //               );
// //               return;
// //             }
// //           } else {
// //             setImgPreview(URL.createObjectURL(file));
// //             setProfileImg(file);
// //           }
// //         } else {
// //           toast("Please select a file in JPG, PNG, HEIC, or JPEG format.", {
// //             position: "top-center",
// //             hideProgressBar: true,
// //             type: "error",
// //           });
// //         }
// //       }
// //     } catch (err) {
// //       consoleService("err in select_profile_image =", err);
// //     }
// //   };

// //   const select_certificates = async (files) => {
// //     try {
// //       const imageTypeRegex = /(application|image)\/(pdf|jpeg|jpg|png|heic)/gm;
// //       const vaildDocs = [];
// //       for (let i = 0; i < files.length; i++) {
// //         const file = files[i];
// //         const maxSize = 3 * 1024 * 1024;
// //         if (file.size > maxSize)
// //           return toast("File size of your documents should not exceed 3 MB.", {
// //             position: "top-center",
// //             hideProgressBar: true,
// //             type: "error",
// //           });
// //         if (file.type.match(imageTypeRegex)) {
// //           if (file.type === "image/heic" || file.name.endsWith(".heic")) {
// //             try {
// //               const blob = await heic2any({
// //                 blob: file,
// //                 toType: "image/jpeg",
// //               });
// //               const convertedFile = new File(
// //                 [blob],
// //                 file.name.replace(".heic", ".jpg"),
// //                 { type: "image/jpeg" }
// //               );
// //               vaildDocs.push(convertedFile);
// //             } catch (error) {
// //               toast(
// //                 "Failed to process HEIC image. Please upload a JPG or PNG instead.",
// //                 {
// //                   position: "top-center",
// //                   hideProgressBar: true,
// //                   type: "error",
// //                 }
// //               );
// //               return;
// //             }
// //           } else {
// //             vaildDocs.push(file);
// //           }
// //         } else {
// //           consoleService("fileType = ", file.type);
// //           return toast("You can select only (pdf,jpeg,jpg,png,heic) files.", {
// //             position: "top-center",
// //             hideProgressBar: true,
// //             type: "error",
// //           });
// //         }
// //       }

// //       if (vaildDocs.length > 0) {
// //         setCertificates(vaildDocs);
// //         return;
// //       }
// //     } catch (err) {
// //       consoleService("error in select certificate", err);
// //     }
// //   };

// //   const select_id_proofs = async (files) => {
// //     try {
// //       const imageTypeRegex = /(application|image)\/(pdf|jpeg|jpg|png|heic)/gm;
// //       const vaildDocs = [];
// //       for (let i = 0; i < files.length; i++) {
// //         const file = files[i];
// //         const maxSize = 3 * 1024 * 1024;
// //         if (file.size > maxSize)
// //           return toast("File size of your documents should not exceed 3 MB.", {
// //             position: "top-center",
// //             hideProgressBar: true,
// //             type: "error",
// //           });
// //         if (file.type.match(imageTypeRegex)) {
// //           if (file.type === "image/heic" || file.name.endsWith(".heic")) {
// //             try {
// //               const blob = await heic2any({
// //                 blob: file,
// //                 toType: "image/jpeg",
// //               });
// //               const convertedFile = new File(
// //                 [blob],
// //                 file.name.replace(".heic", ".jpg"),
// //                 { type: "image/jpeg" }
// //               );
// //               vaildDocs.push(convertedFile);
// //             } catch (error) {
// //               toast(
// //                 "Failed to process HEIC image. Please upload a JPG or PNG instead.",
// //                 {
// //                   position: "top-center",
// //                   hideProgressBar: true,
// //                   type: "error",
// //                 }
// //               );
// //               return;
// //             }
// //           } else {
// //             vaildDocs.push(file);
// //           }
// //         } else {
// //           return toast("You can select only (pdf,jpeg,jpg,png,heic) files.", {
// //             position: "top-center",
// //             hideProgressBar: true,
// //             type: "error",
// //           });
// //         }
// //       }

// //       if (vaildDocs.length > 0) {
// //         setIdProofs(vaildDocs);
// //         return;
// //       }
// //     } catch (err) {
// //       consoleService("error in select proof = ", err);
// //     }
// //   };

// //   const submitFun = async () => {
// //     if (!navigateFrom)
// //       return navigate("/login", {
// //         replace: true,
// //       });
// //     let ConditionCheck = false;
// //     const isCustomPhoneFound = custom_phone.trim() != "";
// //     const isNavigateFromOtpScreen = navigateFrom == "otp_screen";
// //     if (isNavigateFromOtpScreen) {
// //       if (phone) {
// //         ConditionCheck = true;
// //       } else {
// //         ConditionCheck = false;
// //       }
// //     } else {
// //       if (isCustomPhoneFound && validationsRes.phoneErr)
// //         return toast(validationsRes.phoneErr, {
// //           position: "top-center",
// //           hideProgressBar: true,
// //           type: "error",
// //         });
// //       ConditionCheck = true;
// //     }
// //     if (!(calculateAge(dob) >= 12))
// //       return toast("You must be above 12 years of age to register.", {
// //         position: "top-center",
// //         hideProgressBar: true,
// //         type: "error",
// //       });

// //     // Check if all licenses are verified
// //     const hasAllLicensesVerified = licenses.every((lic) => lic.verified);
// //     if (!hasAllLicensesVerified) {
// //       return toast("Please verify all licenses before submitting.", {
// //         position: "top-center",
// //         hideProgressBar: true,
// //         type: "error",
// //       });
// //     }

// //     setSubmit(true);
// //     if (
// //       !validationsRes.firstNameErr &&
// //       !validationsRes.dobErr &&
// //       !validationsRes.emailErr &&
// //       !validationsRes.specialityErr &&
// //       !validationsRes.id_proofsErr &&
// //       termsAndConditions &&
// //       ConditionCheck
// //     ) {
// //       try {
// //         const isPhoneToUpdate = isNavigateFromOtpScreen
// //           ? false
// //           : isCustomPhoneFound
// //           ? true
// //           : false;
// //         if (isPhoneToUpdate) return setShowOtpModal(true);

// //         await register_function(phone);
// //       } catch (err) {
// //         setLoading(false);
// //         consoleService("Error in submit function = ", err);
// //       }
// //     } else {
// //       toast("Some fields are missing.", {
// //         position: "top-center",
// //         hideProgressBar: true,
// //         type: "error",
// //       });
// //     }
// //   };

// //   const register_function = async (phone_no_to_update) => {
// //     try {
// //       setLoading(true);
// //       const formData = new FormData();
// //       formData.append("first_name", firstName);
// //       formData.append("last_name", lastName);
// //       formData.append("dob", date_to_send);
// //       formData.append("email", email);
// //       formData.append("apple_id", apple_id);
// //       formData.append("facebook_id", facebook_id);
// //       formData.append("gender", gender);
// //       formData.append("speciality_type_id", speciality_type_id);
// //       formData.append("supervisor_name", supervisor_name);
// //       formData.append("terms", termsAndConditions);
// //       id_proofs.forEach((item) => {
// //         formData.append("id_proof", item);
// //       });

// //       // Send licenses array instead of single license_number
// //       const licensesData = licenses.map((lic, index) => ({
// //         license_number: lic.license_number,
// //         state: lic.state.length > 0 ? lic.state[0].value : "",
// //         file_path: "",
// //         expiry_date: lic.expiry_date,
// //         verified: lic.verified,
// //       }));
// //       formData.append("licenses", JSON.stringify(licensesData));

// //       // Append license documents
// //       licenses.forEach((lic, index) => {
// //         if (lic.document) {
// //           formData.append(`license_document_${index}`, lic.document);
// //         }
// //       });

// //       formData.append("role", "Therapist");
// //       formData.append("profile_img", profile_img);
// //       formData.append("phone", phone_no_to_update);
// //       formData.append(
// //         "speciality_id",
// //         JSON.stringify(speciality.map((item) => item.value))
// //       );
// //       formData.entries().forEach((entry) => {
// //         console.log(entry);
// //       });
// //       const res = await register_user(formData);
// //       if (res.status === 1) {
// //         window.dataLayer = window.dataLayer || [];
// //         window.dataLayer.push({
// //           event: "therapist_registration",
// //           email: email,
// //           phone: phone_no_to_update,
// //         });
// //         clearFields();
// //         setLoading(false);
// //         setSubmit(false);

// //         navigate("/therapistcompleteprofile", {
// //           state: res.data._id,
// //           replace: true,
// //         });
// //       } else {
// //         setLoading(false);
// //         toast(res.message, {
// //           position: "top-center",
// //           hideProgressBar: true,
// //           type: "error",
// //         });
// //       }
// //     } catch (err) {
// //       consoleService("error in register_function ", err);
// //     }
// //   };

// //   function clearFields() {
// //     setFirstName("");
// //     setLastName("");
// //     setDob("");
// //     setCustomPhone("");
// //     setDateToSend("");
// //     setGender("Male");
// //     setEmail("");
// //     setState("");
// //     setSpeciality("");
// //     setProfileImg("");
// //     setCertificates([]);
// //     setIdProofs([]);
// //     setImgPreview([]);
// //     setSpecialityTypeId("");
// //     phone = "";
// //   }

// //   function Date_model(props) {
// //     const [selectedDate, setSelectedDate] = useState(
// //       dob ? new Date(dob) : new Date(1940, 0, 1)
// //     );
// //     return (
// //       <Modal
// //         {...props}
// //         size="md"
// //         className="modalregs"
// //         aria-labelledby="contained-modal-title-vcenter"
// //         centered
// //         onHide={() => {
// //           setSelectedDate(new Date(dob));
// //           setShowDateModel(false);
// //         }}
// //       >
// //         <Modal.Body className="text-left">
// //           <section className="pb-4 pt-2 packagebox packagebox_book">
// //             <div className="container">
// //               <div className="row">
// //                 <div className="col-md-12">
// //                   <h2>Select Date</h2>
// //                   <Calendar
// //                     onChange={(date) => {
// //                       setSelectedDate(new Date(date));
// //                     }}
// //                     value={selectedDate}
// //                     minDate={new Date(1940, 0, 1)}
// //                     maxDate={new Date()}
// //                     tileClassName="calendar_tiles"
// //                   />
// //                 </div>
// //               </div>
// //             </div>
// //           </section>
// //         </Modal.Body>
// //         <Modal.Footer>
// //           <Button
// //             as={Link}
// //             onClick={(e) => {
// //               e.preventDefault();
// //               setDob(
// //                 `${selectedDate.getFullYear()}/${
// //                   selectedDate.getMonth() + 1
// //                 }/${selectedDate.getDate()}`
// //               );
// //               setDateToSend(selectedDate);
// //               setShowDateModel(false);
// //             }}
// //           >
// //             Done
// //           </Button>
// //         </Modal.Footer>
// //       </Modal>
// //     );
// //   }

// //   return (
// //     <>
// //       <section
// //         className="loginBg"
// //         style={{ backgroundImage: `url(${LoginBg})` }}
// //       >
// //         <div className="container">
// //           <div className="row">
// //             <div className="col-md-12">
// //               <Form>
// //                 <div className="loginBox loginUpdateBox">
// //                   <div className="userImg">
// //                     <Image
// //                       src={imgPreview ? imgPreview : PlaceholderImg}
// //                       className="userImage"
// //                       alt=""
// //                     />
// //                     <div>
// //                       <Image src={EditIcon} className="editIcon" alt="" />
// //                       <input
// //                         type="file"
// //                         accept="image/jpg, image/jpeg , image/heic , image/png"
// //                         className="edit_img"
// //                         multiple={false}
// //                         onChange={(e) => {
// //                           select_profile_img(e.target.files);
// //                         }}
// //                       />
// //                     </div>
// //                   </div>
// //                   <Form.Label>Personal Information</Form.Label>
// //                   <Form.Control
// //                     type="text"
// //                     placeholder="First Name"
// //                     value={firstName}
// //                     onChange={(e) => {
// //                       setFirstName(e.target.value);
// //                     }}
// //                   />
// //                   {submit && validationsRes.firstNameErr && (
// //                     <span className="validations_err" style={errorStyle}>
// //                       {validationsRes.firstNameErr}
// //                     </span>
// //                   )}
// //                   <Form.Control
// //                     type="text"
// //                     placeholder="Last Name"
// //                     value={lastName}
// //                     onChange={(e) => {
// //                       setLastName(e.target.value);
// //                     }}
// //                   />
// //                   <Form.Control
// //                     className="mb-3"
// //                     type="text"
// //                     placeholder="D.O.B."
// //                     value={dob && formetDate(dob)}
// //                     onClick={() => {
// //                       setShowDateModel(true);
// //                     }}
// //                   />
// //                   {submit && validationsRes.dobErr && (
// //                     <span className="validations_err" style={errorStyle}>
// //                       {validationsRes.dobErr}
// //                     </span>
// //                   )}
// //                   <Form.Group
// //                     className="mb-3"
// //                     controlId="exampleForm.ControlInput3"
// //                   >
// //                     <Form.Label>What is your gender?</Form.Label>
// //                     {["radio"].map((type) => (
// //                       <div key={`default-${type}`} className="boxFlex">
// //                         <Form.Check // prettier-ignore
// //                           type={type}
// //                           id="g1"
// //                           label="Male"
// //                           name="gender"
// //                           checked={gender == "Male"}
// //                           onClick={() => {
// //                             setGender("Male");
// //                           }}
// //                         />
// //                         <Form.Check // prettier-ignore
// //                           type={type}
// //                           id="g2"
// //                           label="Female"
// //                           name="gender"
// //                           checked={gender == "Female"}
// //                           onClick={() => {
// //                             setGender("Female");
// //                           }}
// //                         />
// //                         <Form.Check // prettier-ignore
// //                           type={type}
// //                           id="g3"
// //                           label="Unspecified"
// //                           name="gender"
// //                           checked={gender == "Unspecified"}
// //                           onClick={() => {
// //                             setGender("Unspecified");
// //                           }}
// //                         />
// //                       </div>
// //                     ))}
// //                   </Form.Group>
// //                   <Form.Control
// //                     type="text"
// //                     placeholder="Email Address"
// //                     value={email}
// //                     onChange={(e) => {
// //                       (isNavigateFromOptScreen || apple_id.trim()) &&
// //                         setEmail(e.target.value);
// //                     }}
// //                   />
// //                   {submit && validationsRes.emailErr && (
// //                     <span className="validations_err" style={errorStyle}>
// //                       {validationsRes.emailErr}
// //                     </span>
// //                   )}
// //                   {!phone && (
// //                     <Form.Group
// //                       className="mb-3"
// //                       controlId="exampleForm.ControlInput2"
// //                     >
// //                       {/* <Form.Label>Phone Number</Form.Label> */}
// //                       <div className="pbox register_pb_box">
// //                         <div className="callb">
// //                           US{" "}
// //                           <svg
// //                             width="12"
// //                             height="8"
// //                             viewBox="0 0 12 8"
// //                             fill="none"
// //                             x
// //                           >
// //                             <path
// //                               d="M1 1.5L6 6.5L11 1.5"
// //                               stroke="#212529"
// //                               stroke-width="1.66667"
// //                               stroke-linecap="round"
// //                               stroke-linejoin="round"
// //                             />
// //                           </svg>
// //                           <span
// //                             style={{
// //                               color: !custom_phone.trim() ? "#929fa4" : null,
// //                             }}
// //                           >
// //                             +1
// //                           </span>
// //                         </div>
// //                         <Form.Control
// //                           type="text"
// //                           className="register_phone_input"
// //                           value={custom_phone}
// //                           onChange={(e) => {
// //                             const numericValue = e.target.value.replace(
// //                               /[^0-9]/g,
// //                               ""
// //                             );
// //                             setCustomPhone(numericValue);
// //                           }}
// //                           onKeyDown={(e) => {
// //                             if (e.key == "Enter") {
// //                               e.preventDefault();
// //                               // !validationsRes.phoneErr && send_otp_function();
// //                             }
// //                           }}
// //                           placeholder="(555) 000-0000"
// //                         />
// //                       </div>
// //                     </Form.Group>
// //                   )}

// //                   <Form.Group
// //                     className="mb-3"
// //                     controlId="exampleForm.ControlInput3"
// //                   >
// //                     <MultiSelect
// //                       options={specialityList}
// //                       value={speciality}
// //                       onChange={setSpeciality}
// //                       labelledBy="Select Specialty"
// //                       className="checkBoxNew"
// //                     />
// //                   </Form.Group>
// //                   {submit && validationsRes.specialityErr && (
// //                     <span className="validations_err" style={errorStyle}>
// //                       {validationsRes.specialityErr}
// //                     </span>
// //                   )}
// //                   <Form.Label>Licensing Information</Form.Label>
// //                   <Form.Group
// //                     className="mt-3"
// //                     controlId="exampleForm.ControlInput3"
// //                   >
// //                     {licenses.map((lic, index) => (
// //                       <div
// //                         key={index}
// //                         className="licenseBox shadow p-3 mt-3 mb-3 bg-body rounded position-relative"
// //                       >
// //                         <div className="d-flex align-items-center  pb-1">
// //                           <p className="mb-0 me-2">Sr.No {index + 1}</p>
// //                           {lic.verified && (
// //                             <span
// //                               className="badge bg-success"
// //                               style={{ fontSize: "12px" }}
// //                             >
// //                               Verified
// //                             </span>
// //                           )}
// //                         </div>
// //                         {/* REMOVE BUTTON */}
// //                         {licenses.length > 1 && (
// //                           <FaTimes
// //                             className="position-absolute"
// //                             style={{
// //                               top: 10,
// //                               right: 10,
// //                               cursor: isAnyLicenseVerifying
// //                                 ? "not-allowed"
// //                                 : "pointer",
// //                               color: "red",
// //                               opacity: isAnyLicenseVerifying ? 0.5 : 1,
// //                             }}
// //                             onClick={() => {
// //                               if (!isAnyLicenseVerifying) {
// //                                 const updated = [...licenses];
// //                                 updated.splice(index, 1);
// //                                 setLicenses(updated);
// //                               }
// //                             }}
// //                           />
// //                         )}

// //                         <Form.Control
// //                           type="text"
// //                           placeholder="License Number"
// //                           value={lic.license_number}
// //                           onChange={(e) => {
// //                             if (!lic.verified && !isAnyLicenseVerifying) {
// //                               const updated = [...licenses];
// //                               updated[index].license_number =
// //                                 e.target.value.toUpperCase();
// //                               setLicenses(updated);
// //                             }
// //                           }}
// //                           disabled={lic.verified || isAnyLicenseVerifying} // disable if verified or any license verifying
// //                           style={{
// //                             textTransform: lic.license_number
// //                               ? "uppercase"
// //                               : "none",
// //                           }}
// //                         />

// //                         <Select
// //                           placeholder="Select State"
// //                           options={statesList}
// //                           values={lic.state}
// //                           onChange={(value) => {
// //                             if (!lic.verified && !isAnyLicenseVerifying) {
// //                               const updated = [...licenses];
// //                               updated[index].state = value;
// //                               setLicenses(updated);
// //                             }
// //                           }}
// //                           multi={false}
// //                           disabled={lic.verified || isAnyLicenseVerifying}
// //                           style={{
// //                             color: lic.verified ? "#212529" : undefined,
// //                             borderColor: lic.verified ? "#E9ECEF" : undefined,
// //                             opacity: lic.verified ? 1 : undefined,
// //                             backgroundColor: lic.verified
// //                               ? "#E9ECEF"
// //                               : undefined,
// //                           }}
// //                           dropdownHandleRenderer={({ state }) => (
// //                             <span
// //                               style={{
// //                                 color: lic.verified ? "#212529" : undefined,
// //                                 opacity: lic.verified ? 0 : undefined,
// //                               }}
// //                             >
// //                               {state.dropdown ? (
// //                                 <FaChevronUp />
// //                               ) : (
// //                                 <FaChevronDown />
// //                               )}
// //                             </span>
// //                           )}
// //                         />

// //                         {/* UPLOAD BOX */}
// //                         <div className="uploadBox mt-3">
// //                           <p>Please upload proof of license certification</p>
// //                           <div
// //                             className="file"
// //                             style={{
// //                               position: "relative",
// //                               cursor:
// //                                 lic.verified || isAnyLicenseVerifying
// //                                   ? "not-allowed"
// //                                   : "pointer",
// //                             }}
// //                             onClick={() => {
// //                               if (!lic.verified && !isAnyLicenseVerifying)
// //                                 document
// //                                   .getElementById(`license-file-${index}`)
// //                                   .click();
// //                             }}
// //                           >
// //                             {licenses[index].document ? (
// //                               licenses[index].document.type.includes(
// //                                 "image"
// //                               ) ? (
// //                                 <img
// //                                   src={URL.createObjectURL(
// //                                     licenses[index].document
// //                                   )}
// //                                   alt="preview"
// //                                   style={{
// //                                     width: "100%",
// //                                     height: "150px",
// //                                     objectFit: "contain",
// //                                     border: "1px solid #ccc",
// //                                   }}
// //                                 />
// //                               ) : (
// //                                 <div
// //                                   style={{
// //                                     width: "100%",
// //                                     height: "150px",
// //                                     border: "1px solid #ccc",
// //                                     display: "flex",
// //                                     alignItems: "center",
// //                                     justifyContent: "center",
// //                                     flexDirection: "column",
// //                                   }}
// //                                 >
// //                                   <FaFilePdf size={40} color="red" />
// //                                   <p style={{ fontSize: "12px", marginTop: 5 }}>
// //                                     {licenses[index].document.name}
// //                                   </p>
// //                                 </div>
// //                               )
// //                             ) : (
// //                               <span
// //                                 className="select_license_document_box"
// //                                 htmlFor={`license-file-${index}`}
// //                               >
// //                                 <FaCloudUploadAlt /> Upload document
// //                               </span>
// //                             )}
// //                             <input
// //                               id={`license-file-${index}`}
// //                               type="file"
// //                               accept=".pdf,.jpg,.jpeg,.png,.heic"
// //                               style={{ display: "none" }}
// //                               onChange={async (e) => {
// //                                 if (!lic.verified && !isAnyLicenseVerifying) {
// //                                   const file = e.target.files[0];
// //                                   const updated = [...licenses];

// //                                   // Check if file was selected
// //                                   if (!file) {
// //                                     updated[index].document = null;
// //                                     setLicenses(updated);
// //                                     return;
// //                                   }

// //                                   // Validate file type
// //                                   const validTypes = [
// //                                     "image/jpeg",
// //                                     "image/png",
// //                                     "image/jpg",
// //                                     "application/pdf",
// //                                     "image/heic",
// //                                   ];
// //                                   if (!validTypes.includes(file.type)) {
// //                                     toast(
// //                                       "Invalid file type. Only JPG, PNG, PDF, HEIC allowed",
// //                                       {
// //                                         position: "top-center",
// //                                         hideProgressBar: true,
// //                                         type: "error",
// //                                       }
// //                                     );
// //                                     updated[index].document = null;
// //                                     setLicenses(updated);
// //                                     return;
// //                                   }

// //                                   // Validate file size (10MB)
// //                                   if (file.size > 10 * 1024 * 1024) {
// //                                     toast("File size exceeds 10MB limit", {
// //                                       position: "top-center",
// //                                       hideProgressBar: true,
// //                                       type: "error",
// //                                     });
// //                                     updated[index].document = null;
// //                                     setLicenses(updated);
// //                                     return;
// //                                   }

// //                                   // Handle HEIC conversion if needed
// //                                   if (
// //                                     file.type === "image/heic" ||
// //                                     file.name.endsWith(".heic")
// //                                   ) {
// //                                     try {
// //                                       const blob = await heic2any({
// //                                         blob: file,
// //                                         toType: "image/jpeg",
// //                                       });
// //                                       const convertedFile = new File(
// //                                         [blob],
// //                                         file.name.replace(".heic", ".jpg"),
// //                                         { type: "image/jpeg" }
// //                                       );
// //                                       updated[index].document = convertedFile;
// //                                     } catch (error) {
// //                                       toast(
// //                                         "Failed to process HEIC image. Please upload a JPG or PNG instead.",
// //                                         {
// //                                           position: "top-center",
// //                                           hideProgressBar: true,
// //                                           type: "error",
// //                                         }
// //                                       );
// //                                       updated[index].document = null;
// //                                       setLicenses(updated);
// //                                       return;
// //                                     }
// //                                   } else {
// //                                     // Set valid file
// //                                     updated[index].document = file;
// //                                   }

// //                                   setLicenses(updated);
// //                                 }
// //                               }}
// //                             />
// //                           </div>
// //                           <small>
// //                             File size of your documents should not exceed 10 MB
// //                           </small>
// //                         </div>

// //                         {/* VERIFY BUTTON */}
// //                         {!lic.verified &&
// //                           lic.license_number &&
// //                           lic.state.length > 0 &&
// //                           lic.document && (
// //                             <>
// //                               <Button
// //                                 className="mt-2"
// //                                 onClick={() => verifyLicense(index)}
// //                                 disabled={
// //                                   lic.verifying || isAnyLicenseVerifying
// //                                 }
// //                               >
// //                                 {lic.verifying ? "Verifying..." : "Verify"}
// //                               </Button>
// //                               {lic.verifying && (
// //                                 <div
// //                                   className="mt-2 p-2"
// //                                   style={{
// //                                     backgroundColor: "#e3f2fd",
// //                                     border: "1px solid #1D7E7C",
// //                                     borderRadius: "5px",
// //                                     fontSize: "14px",
// //                                     color: "#1A3D3C",
// //                                   }}
// //                                 >
// //                                   <div className="d-flex align-items-center">
// //                                     <div
// //                                       className="spinner-border spinner-border-sm me-2"
// //                                       role="status"
// //                                     >
// //                                       <span className="visually-hidden">
// //                                         Loading...
// //                                       </span>
// //                                     </div>
// //                                     <span>
// //                                       <strong>Verifying your license...</strong>
// //                                       <br />
// //                                       Processing your request, this may take a
// //                                       moment.
// //                                     </span>
// //                                   </div>
// //                                 </div>
// //                               )}
// //                             </>
// //                           )}

// //                         {/* EXPIRY DATE */}
// //                         {lic.verified && (
// //                           <>
// //                             <Form.Label className="mt-2">
// //                               License Expiry Date
// //                             </Form.Label>
// //                             <Form.Control
// //                               type="text"
// //                               style={{ backgroundColor: "#E9ECEF" }}
// //                               placeholder="Expiry Date"
// //                               value={lic.expiry_date}
// //                               readOnly
// //                             />
// //                           </>
// //                         )}
// //                       </div>
// //                     ))}

// //                     {licenses.every((lic) => lic.verified) &&
// //                       !isAnyLicenseVerifying && (
// //                         <Button
// //                           className="mb-3"
// //                           onClick={() =>
// //                             setLicenses([
// //                               ...licenses,
// //                               {
// //                                 license_number: "",
// //                                 state: [],
// //                                 document: null,
// //                                 expiry_date: "",
// //                                 verified: false,
// //                                 verifying: false,
// //                               },
// //                             ])
// //                           }
// //                           disabled={isAnyLicenseVerifying}
// //                         >
// //                           Add More License
// //                         </Button>
// //                       )}
// //                     {submit && validationsRes.license_numberErr && (
// //                       <span className="validations_err" style={errorStyle}>
// //                         {validationsRes.license_numberErr}
// //                       </span>
// //                     )}
// //                   </Form.Group>

// //                   <Form.Control
// //                     type="text"
// //                     placeholder="Supervisor's Name (if applicable)"
// //                     value={supervisor_name}
// //                     onChange={(e) => {
// //                       setSupervisorName(e.target.value);
// //                     }}
// //                   />

// //                   <Form.Group
// //                     className="mb-3"
// //                     controlId="exampleForm.ControlInput3"
// //                   >
// //                     <div className="uploadBox">
// //                       <p>
// //                         Please upload your state ID card or state driver license
// //                       </p>
// //                       <div className="file">
// //                         {id_proofs.length > 0 ? (
// //                           id_proofs.length == 1 ? (
// //                             <label htmlFor="input-file2">
// //                               {id_proofs.length} ID selected
// //                             </label>
// //                           ) : (
// //                             <label htmlFor="input-file2">
// //                               {id_proofs.length} ID's selected
// //                             </label>
// //                           )
// //                         ) : (
// //                           <label htmlFor="input-file2">
// //                             <FaCloudUploadAlt /> Upload ID
// //                           </label>
// //                         )}
// //                         <input
// //                           id="input-file2"
// //                           type="file"
// //                           accept=".pdf,.jpg,.jpeg,.png,.heic"
// //                           onChange={(e) => {
// //                             select_id_proofs(e.target.files);
// //                           }}
// //                           multiple
// //                         />
// //                       </div>
// //                       <small>
// //                         File size of your documents should not exceed 3 MB
// //                       </small>
// //                     </div>
// //                   </Form.Group>
// //                   {submit && validationsRes.id_proofsErr && (
// //                     <span className="validations_err" style={errorStyle}>
// //                       {validationsRes.id_proofsErr}
// //                     </span>
// //                   )}
// //                   <Form.Group
// //                     className="mb-4"
// //                     controlId="exampleForm.ControlInput3"
// //                   >
// //                     <Form.Label>HIPAA Compliance</Form.Label>
// //                     {["checkbox"].map((type) => (
// //                       <div key={`default-${type}`} className="mb-3 termBox">
// //                         <Form.Check // prettier-ignore
// //                           type={type}
// //                           id="1"
// //                           checked={termsAndConditions}
// //                           label={
// //                             <span>
// //                               I accept the{" "}
// //                               <Link
// //                                 to=""
// //                                 onClick={(e) => {
// //                                   e.preventDefault();
// //                                   window.open("/termsofservice");
// //                                 }}
// //                                 className="linkhip"
// //                               >
// //                                 terms and conditions
// //                               </Link>
// //                               {" - "}
// //                               <Link
// //                                 to=""
// //                                 onClick={(e) => {
// //                                   e.preventDefault();
// //                                   window.open("/hipaa");
// //                                 }}
// //                                 className="linkhip"
// //                               >
// //                                 HIPAA
// //                               </Link>{" "}
// //                               while sharing my details
// //                             </span>
// //                           }
// //                           onClick={() => {
// //                             setTermsAndConditions(!termsAndConditions);
// //                           }}
// //                         />
// //                       </div>
// //                     ))}
// //                   </Form.Group>
// //                   <Button
// //                     className="btn btn-primary me-3"
// //                     onClick={() => {
// //                       submitFun();
// //                     }}
// //                     disabled={!termsAndConditions}
// //                   >
// //                     Submit
// //                   </Button>
// //                 </div>
// //               </Form>
// //             </div>
// //           </div>
// //         </div>
// //       </section>
// //       {show_otp_modal && (
// //         <Otp_model_for_register
// //           show={true}
// //           onHide={() => {
// //             setShowOtpModal(false);
// //           }}
// //           verify_type="update_profile"
// //           phone_number={custom_phone}
// //           register_function={register_function}
// //         />
// //       )}
// //       <Date_model show={showDateModel} />
// //     </>
// //   );
// // };

// // export default TherapistRegisteration;
